import { Alert, Checkbox, Col, Form, Flex, Row, Switch, Skeleton, Image, Tooltip, Input, Popconfirm, Tabs, message, Collapse, Badge, Button } from "antd";
import CopyToClipboard from "../../../components/CopyToClipboard";
import StyledModal from "../../../components/CustomModal";
import { EnvironmentOutlined, InfoCircleOutlined, ClockCircleOutlined, FireFilled, BookOutlined, ContactsOutlined, PlusOutlined, CheckOutlined, LoadingOutlined } from "@ant-design/icons";
import React, { useMemo, useState, useEffect, useCallback } from "react";
import { CaretRightOutlined } from "@ant-design/icons";
import { ReactComponent as EmailUnreadIcon } from "../../../assets/images/emailUnread.svg";
import { ReactComponent as StickyNoteIcon } from "../../../assets/images/stickyNote.svg";
import { ReactComponent as BoxIcon } from "../../../assets/images/BoxIcon.svg";
import { ReactComponent as SubBoxIcon } from "../../../assets/images/SubBoxIcon.svg";
import { ReactComponent as UserRound } from "../../../assets/images/UserRound.svg";
import { ReactComponent as PhoneOneIcon } from "../../../assets/images/phone1.svg";
import { ReactComponent as PhoneTwoIcon } from "../../../assets/images/phone2.svg";
import { ReactComponent as EnvelopeOpenOneIcon } from "../../../assets/images/envelopeOpen1.svg";
import { ReactComponent as EnvelopeOpenTwoIcon } from "../../../assets/images/envelopeOpen2.svg";
import { ReactComponent as FlightTakeOffIcon } from "../../../assets/images/flightTakeOff.svg";
import { ReactComponent as FlightTakeLandIcon } from "../../../assets/images/flightTakeLand.svg";
import { ReactComponent as SailingIcon } from "../../../assets/images/sailing.svg";
import { ReactComponent as DistanceIcon } from "../../../assets/images/distance.svg";
import { ReactComponent as QuestionMark } from "../../../assets/images/question_mark.svg";
import { ReactComponent as CheckCircleIcon } from "../../../assets/images/check_circle.svg"
import { ReactComponent as StickyIcon } from "../../../assets/images/sticky_activity.svg";
import EstablishmentPopover from "./EstablishmentPopover";
import ContactPopover from "./ContactPopover";
import PlacesContactsDrawer from "../../EstablishmentType/PlacesContactsDrawer";
import EstablishmentLocationModal from "../../EstablishmentType/EstablishmentLocationModal";

import dayjs from "dayjs";

import {
  AddButtonWarper,
  ButtonWarper,
  CardWrapper,
  DisabledContent,
  EditIcon,
  FlexWrapper,
  IconWrapper,
  ImageContainer,
  ImageWrapper,
  InnerFlex,
  MainTitle,
  ReportDetailsCart,
  CustomCollapse,
  ReportDetailsWrapper,
  StyledCol,
  StyledFlex,
  StyledLabel,
  StyledTitle,
  StyledUserIcon,
  SubItemContainer,
  SubItemIcon,
  SubItemText,
  TableContainer,
  TextSubWrapper,
  Timestamp,
  UpdatedText,
  StrikethroughText,
  StyledStickyButtonWrapper,
  StyledStickyButtonText,
  StickyWrapper,
  ActivityIconWrapper,
  SVGIconWrapper,
  ActivityWrapper,
  NewItemBadge,
  DeletedItemBadge,
} from "./style";
import MarkAsUrgentModal from "./MarkAsUrgentModal";
import { ActivationStatus, PaymentStatus, Report, User, Item } from "../../../types";
import Images from "./ImageContent";
import { DownloadDonateIcon, PaymentTermsIcon, ReceiptIcon, ServiceCompletionIcon } from "./Icon";
import apiClient from "../../../utils/constants/apiClient";
import { apiEndpoints } from "../../../utils/constants/apiEndpoints";
import { useAppDispatch, useAppSelector } from "../../../utils/hooks/redux";
import { passPendingRequest, rejectPendingRequest, getReportVersionAsyncThunk, updateLostItemIsUrgent } from "../../../redux/features/report/reportAsyncThunk";
import { clearVersionData, updateReportStatus, updateReportLFNotifications } from "../../../redux/features/report/reportSlice";
import { convertIntoBoardTicket, updateTicketLocally, updateTicketStatusLocally } from "../../../redux/features/board/columnsSlice";
import { fetchSchedulerInterval } from "../../../redux/features/schedulerSettings/schedulerSettingsAsyncThunk";
import Notification from "../../../components/Notification";
import PreMatchFoundItem from "../PreMatchFoundItem";
import { LostStatuses, PendingRequestOperation } from "../../../types/LostStatuses";
// import { StrikethroughText, UpdatedText, DisabledContent, StyledTabs } from "./style";
import { useNavigate } from "react-router-dom";
import SystemPayRoutes from "../../../utils/constants/Routes";
import { StyledTabs } from "./style";
import EditReportDetailsModal from "../Modal/EditReportDetailsModal";
import { toast } from "react-toastify";
import AddUpdateStickyModal from "../Modal/AddUpdateStickyModal";
import ConfirmationModal from "../../../components/ConfirmationModal";
import { toggleEmailCommunication } from "../../../redux/features/generaleWebData/generaleWebDataAsyncThunk";
import { createSticky, fetchSticky, updateSticky } from "../../../redux/features/sticky/stickyAsyncThunk";
import { selectStickys } from "../../../redux/features/sticky/stickySlice";
import { convertUtcToLocal, convertUtcToLocalAndRelativeTime } from "../../../utils/helpers/convertUtcToLocal";
import { sortLostItemLogsData, sortStickyData } from "../../../utils/helpers/sortStickyData";
import { lostReportStatusOptions, LostToFoundStatusMap } from "../utils/const";
import { RequestResults } from "../../../redux/common/RequestStatus";
import { selectActivityLog } from "../../../redux/features/activityLog/activityLogSlice";
import { fetchAllLostItemLogs, updateNoteByAdmin } from "../../../redux/features/activityLog/activityLogAsyncThunk";
import AddComment from "./AddComment";
import AddUpdateCommentModal from "../Modal/AddUpdateCommentModal";
import { Divider } from "../styles";
import ShippingModal from "../../../common/Shipping";
import { ReactComponent as BarcodeIcon } from "../../../assets/images/barcode_scanner.svg";
import { mergePendingIntoOriginal } from "../../../utils/helpers/updateQuestionAnswers";
import { sortByDate } from "../../../utils/helpers/sortOptionsAlphabetically";
import { updateLostItemStatus, updateLFNotifications, updateLFNotificationComment } from "../../../redux/features/board/columnsAsyncThunk";
import LFNotifiedModal, { LFDepartmentDetails } from "../ReportDetailsHeader/LFNotifiedModal";
import { findLatestDocument, handleDownloadDocument } from "../../../utils/helpers/downloadDocument";
import { selectUserRole } from "../../../redux/features/auth/selectors";
import { checkHasPermission } from "../../../utils/helpers/checkHasPermission";
import { permissions } from "../../../utils/constants/permissions";
import ReportActivityLogs from "./ReportActivityLogs";
import { updateFoundItemStatus } from "../../../redux/features/foundReport/foundReportAsyncThunk";
import { useFetchReport } from "../../../utils/hooks/useFetchReport";
import { shipMatchEnabled } from "../../../utils/constants";
import SignatureInfo from "./SignatureInfo";
import { fetchSingleEstablishmentLocation, addEstablishmentLocation, updateEstablishmentLocation } from "../../../redux/features/establishmentLocation/establishmentLocationAsyncThunk";
import { EstablishmentLocation } from "../../../types";

interface ReportDetailsBodyProps {
  report: Report | null;
  isLoading: boolean;
  versionData: Report | null;
}


const ReportDetailsBody: React.FC<ReportDetailsBodyProps> = ({ report, isLoading, versionData }) => {
  const reportPendingRequest = useMemo(() => {
    if (report?.pendingRequest?.id) {
      return report?.pendingRequest;
    }
    return { id: "", operation: "" };
  }, [report?.pendingRequest]);

  const isDeleteRequest = reportPendingRequest?.operation === PendingRequestOperation.Delete;
  const isUpdateRequest = reportPendingRequest?.operation === PendingRequestOperation.Update;
  const isUpdateShippingInfoRequest = reportPendingRequest?.operation === PendingRequestOperation.UpdateShippingInfo;
  const deleteWithUnlinkRequestTitle = useMemo(() => {
    return isDeleteRequest && report?.foundItem?.id ? `Are you sure you want to unlink found item ${report?.foundItem?.itemNumber} and approve delete request?` : isDeleteRequest ? "Are you sure you want to approve this delete request?" : "";
  }, [isDeleteRequest, report?.foundItem]);
  const showEditButtons = (tabType: "latest" | "pending" | "original" | "version") => {
    const versionCount = (report?.versionCount ?? 0);
    return (tabType === "latest" || (tabType === "original" && versionCount <= 1) || (tabType === "pending" && !isDeleteRequest)) && !reportPendingRequest?.id;
  };

  const [tabType, setTabType] = useState<"latest" | "pending" | "original" | "version">(() => {
    if (reportPendingRequest?.id) {
      return "pending";
    }
    if ((report?.versionCount ?? 0) > 1) {
      return "latest";
    }
    return "original";
  });

  const [form] = Form.useForm();
  const [commentForm] = Form.useForm();
  const [unlinkForm] = Form.useForm();
  const [isMarkModalOpen, setIsMarkModalOpen] = useState(false);
  const [isEditNoteModalOpen, setIsEditNoteModalOpen] = useState(false);
  const [isModalOpenMarkAsUrgent, setIsModalOpenMarkAsUrgent] = useState(false);
  const [editingRecord, setEditingRecord] = useState<any | null>(null);
  const [loading, setLoading] = useState(false);
  const notAvailable = "N/A";
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const preMatchedFoundItems = useAppSelector((state) => state.report.preMatchedFoundItems);
  const [activeData, setActiveData] = useState<Report | null>(null);
  const dataToRender = activeData || report;

  const [isEditReportModalOpen, setIsEditReportModalOpen] = useState(false);
  const [isMarkAsDoneOpen, setIsMarkAsDoneOpen] = useState(false);
  const [isMarkAsDoneLoading, setIsMarkAsDoneLoading] = useState(false);
  const [isEmailCommunication, setIsEmailCommunication] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);

  const [stickyModalType, setStickyModalType] = useState<"add" | "update" | null>(null);
  const [addUpdateStickyLoading, setAddUpdateStickyLoading] = useState(false);
  const [addUpdateCommentLoading, setAddUpdateCommentLoading] = useState(false);
  const [checkedItems, setCheckedItems] = useState<any>({});

  const { data: stickyData, status: stickyStatus } = useAppSelector(selectStickys);
  const { data: lostItemLogsData, status: lostItemLogStatus } = useAppSelector(selectActivityLog);
  const columns = useAppSelector((state) => state.columns.tickets);

  const stickyDataSorted = useMemo(() => sortStickyData(stickyData), [stickyData]);
  const lostItemLogsDataSorted = useMemo(() => sortLostItemLogsData(lostItemLogsData), [lostItemLogsData]);

  const openStickys = useMemo(() => stickyDataSorted?.filter((sticky) => sticky.status === ActivationStatus.Active), [stickyDataSorted])
  const [showConfirmItemMove, setShowConfirmItemMove] = useState<any | null>(null);
  const [isShippingModal, setIsShippingModal] = useState(false);
  const [isSignatureVerificationModal, setIsSignatureVerificationModal] = useState(false);
  const [serviceCompletionLoading, setServiceCompletionLoading] = useState(false);
  const fetchReport = useFetchReport();
  const userRole = useAppSelector(selectUserRole);

  const handleServiceCompletion = useCallback(async (lostId: string) => {
    setServiceCompletionLoading(true);
    try {
      const response = await apiClient.post(`${apiEndpoints.lost.generateServiceCompletion}/${lostId}`, {}, { timeout: 60000 });
      if (response?.data?.success && response?.data?.data?.fullUrl) {
        const fileUrl = response.data.data.fullUrl;
        const res = await fetch(fileUrl);
        const blob = await res.blob();
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `Proof_of_Service_Completion_Claim_${report?.trackingId || lostId}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        message.success("Service Completion PDF downloaded");
      } else {
        message.error(response?.data?.message || "Failed to generate Service Completion PDF");
      }
    } catch (error: any) {
      message.error(error?.response?.data?.message || "Failed to generate Service Completion PDF");
    } finally {
      setServiceCompletionLoading(false);
    }
  }, [report?.trackingId]);

  // Establishment management state
  const [establishmentDrawerVisible, setEstablishmentDrawerVisible] = useState(false);
  const [establishmentModalVisible, setEstablishmentModalVisible] = useState(false);
  const [selectedEstablishment, setSelectedEstablishment] = useState<EstablishmentLocation | null>(null);
  const [establishmentLoading, setEstablishmentLoading] = useState(false);
  const [currentEstablishmentTypeId, setCurrentEstablishmentTypeId] = useState<string>("");

  // L&F Contacts modal state
  const [showBodyLFModal, setShowBodyLFModal] = useState(false);
  const [bodyLFLoading, setBodyLFLoading] = useState(false);
  const [showEmailConfirmModal, setShowEmailConfirmModal] = useState(false);
  const [pendingLFDetails, setPendingLFDetails] = useState<LFDepartmentDetails[]>([]);
  const [emailCheckedIndices, setEmailCheckedIndices] = useState<number[]>([]);
  const [savingFields, setSavingFields] = useState<Record<string, boolean>>({});
  const [savedFields, setSavedFields] = useState<Record<string, boolean>>({});

  const hasPermission = useCallback(
    (permissionKey: string) => checkHasPermission(userRole, permissionKey),
    [userRole]
  );

  useEffect(() => {
    setActiveData(report);
    setIsEmailCommunication(report?.isEmailCommunication || false);
  }, [report]);

  // Ensure the refund-window countdown is accurate when the admin opens a report directly,
  // without first visiting the Reports board (which is the other place that loads this config).
  useEffect(() => {
    dispatch(fetchSchedulerInterval());
  }, [dispatch]);

  const isAccessPaymentLogs = useMemo(() => hasPermission(permissions.IsPaymentLogAllowed), [hasPermission]);

  useEffect(() => {
    if (dataToRender?.id) {
      dispatch(fetchSticky({ lostId: dataToRender?.id, withDeleted: dataToRender?.status === LostStatuses.Deleted }));
      dispatch(fetchAllLostItemLogs({ lostId: dataToRender?.id, withDeleted: dataToRender?.status === LostStatuses.Deleted, keepPaymentLog: isAccessPaymentLogs }));
    }
  }, [dispatch, dataToRender, isAccessPaymentLogs]);

  useEffect(() => {
    if (report?.pendingRequest?.id) {
      setTabType("pending");
    } else if ((report?.versionCount ?? 0) > 1) {
      setTabType("latest");
    } else {
      setTabType("original");
    }
  }, [report]);


  const isTrackingDocAddPermission = useMemo(() => hasPermission(permissions.AddEditTrackingDocs), [hasPermission]);
  const isTrackingDocEditPermission = useMemo(() => hasPermission(permissions.AddEditTrackingDocs), [hasPermission]);
  const isTrackingDocDeletePermission = useMemo(() => hasPermission(permissions.DeleteTrackingDocs), [hasPermission]);
  const isApproveDisApproveCustomerEditRequest = useMemo(() => hasPermission(permissions.ApproveDisApproveCustomerEditRequest), [hasPermission]);
  const isApproveDisApproveCustomerDeleteRequest = useMemo(() => hasPermission(permissions.ApproveDisApproveCustomerDeleteRequest), [hasPermission]);
  const isApproveDisApproveBillingInfoEditRequest = useMemo(() => hasPermission(permissions.ApproveDisApproveBillingInfoEditRequest), [hasPermission]);
  const isMarkStickyAsDonePermission = useMemo(() => hasPermission(permissions.MarkStickyAsDone), [hasPermission]);

  const onChange = async (checked: boolean) => {
    setIsEmailCommunication(checked);
    const response = await dispatch(toggleEmailCommunication({ id: report?.id, data: { isEmailCommunication: checked } })).unwrap();
    if (response?.success) {
      toast.success(`Email communication ${isEmailCommunication ? "disabled" : "enabled"} successfully`);
    }
  };

  const handleIsUrgentChange = async (checked: boolean) => {
    setIsModalOpenMarkAsUrgent(true);
  };

  const handleCheckboxChange = (e: any, item: any) => {
    const updatedCheckedItems = {
      ...checkedItems,
      [item.id]: e.target.checked,
    };
    setIsMarkAsDoneOpen(true);
    setCheckedItems(updatedCheckedItems);
    setEditingRecord(item);
  };

  const onCancel = () => {
    form.resetFields();
    setIsMarkAsDoneOpen(false);
    setEditingRecord(null);
    setIsMarkAsDoneLoading(false);
    setCheckedItems({});
  }

  const handleSave = async () => {
    try {
      setIsMarkAsDoneLoading(true);
      if (editingRecord?.id) {
        await dispatch(updateSticky({ ...editingRecord, status: editingRecord.status === ActivationStatus.Active ? ActivationStatus.Inactive : ActivationStatus.Active, lost: dataToRender?.id })).unwrap();
        onCancel();
      }
    } catch (error) {
      console.error("update sticky error:", error);
      setIsMarkAsDoneLoading(false);
    }
  }

  const handleUpdateTicketStatus = async (value: any) => {
    if (report?.id && !report?.pendingRequest?.id) {
      setLoading(true);
      try {
        const sourceStatus = report?.status;
        await dispatch(
          updateLostItemStatus({
            id: report?.id?.toString(),
            status: value,
          })
        ).unwrap();
        await dispatch(updateReportStatus({ status: value }))
        const findUrgentItem = columns[LostStatuses.Urgent].find((item) => item?.id === report?.id);
        if (findUrgentItem?.id) {
          const response = await dispatch(updateLostItemIsUrgent({ id: findUrgentItem?.id, isUrgent: false })).unwrap();
          if (response) {
            await dispatch(updateTicketLocally({ ticket: convertIntoBoardTicket({ ...report, isUrgent: false }) }));
          }
        }
        if (report?.foundItem?.id && LostToFoundStatusMap[value]) {
          await dispatch(updateFoundItemStatus({ id: report?.foundItem?.id, status: Number(LostToFoundStatusMap[value]) }))
        }
        message.success({
          content: (
            <>
              Status changed from {lostReportStatusOptions?.map((status) => (status.value === report?.status ? status.label : ""))} to{" "}
              <b>{lostReportStatusOptions?.map((status) => (status.value === value ? status.label : ""))}</b>
            </>
          ),
        });
        await dispatch(updateTicketStatusLocally({ ticket: convertIntoBoardTicket(report), sourceStatus, targetStatus: value }));
        setShowConfirmItemMove(false);
      } catch (error) {
        console.log({ error });
      } finally {
        setLoading(false);
      }
    }
  };

  const handleMarkCancel = () => {
    form.resetFields();
    setIsMarkModalOpen(false);
    setEditingRecord(null);
    setStickyModalType(null);
    setAddUpdateStickyLoading(false);
  };

  const handleCommentCancel = () => {
    setIsEditNoteModalOpen(false)
    setAddUpdateCommentLoading(false)
  };

  const handleFormSubmit = async (values: any) => {
    const fixedValues = {
      ...values,
      status: values.status ? ActivationStatus.Active : ActivationStatus.Inactive,
      lost: dataToRender?.id,
      id: editingRecord?.id
    };

    try {
      setAddUpdateStickyLoading(true);
      if (editingRecord?.id) {
        await dispatch(updateSticky({ ...editingRecord, ...fixedValues, status: values.status ? ActivationStatus.Inactive : ActivationStatus.Active })).unwrap();
        handleMarkCancel();
      } else {
        await dispatch(createSticky(fixedValues)).unwrap();
        handleMarkCancel();
      }
    } catch (error) {
      console.error("Create sticky error:", error);
      setAddUpdateStickyLoading(false);
    }
  };

  // Establishment management handlers
  const handleManageEstablishment = async (establishmentId: string) => {
    try {
      setEstablishmentLoading(true);
      const result = await dispatch(fetchSingleEstablishmentLocation(establishmentId)).unwrap();
      setSelectedEstablishment(result);
      setEstablishmentDrawerVisible(true);
    } catch (error) {
      console.error("Failed to fetch establishment:", error);
      toast.error("Failed to load establishment details");
    } finally {
      setEstablishmentLoading(false);
    }
  };

  const handleAddEstablishment = (establishmentTypeId: string) => {
    setCurrentEstablishmentTypeId(establishmentTypeId);
    setSelectedEstablishment(null);
    setEstablishmentModalVisible(true);
  };

  const handleSaveEstablishment = async (values: any) => {
    try {
      setEstablishmentLoading(true);
      const formData = new FormData();

      Object.keys(values).forEach((key) => {
        if (key === 'icon' && values[key]?.length > 0) {
          if (values[key][0].originFileObj) {
            formData.append('icon', values[key][0].originFileObj);
          }
        } else if (key === 'establishmentTypeIds' && Array.isArray(values[key])) {
          // Handle multiple establishment types
          values[key].forEach((typeId: string) => {
            formData.append('establishmentTypeIds', typeId);
          });
        } else if (values[key] !== undefined && values[key] !== null) {
          formData.append(key, values[key]);
        }
      });

      if (selectedEstablishment) {
        await dispatch(updateEstablishmentLocation({ id: selectedEstablishment.id, formData })).unwrap();
        toast.success("Establishment updated successfully");
      } else {
        await dispatch(addEstablishmentLocation({ formData })).unwrap();
        toast.success("Establishment created successfully");
      }

      setEstablishmentModalVisible(false);
      // Refresh report to get updated establishment data
      if (report?.id) {
        fetchReport(report.id);
      }
    } catch (error) {
      console.error("Failed to save establishment:", error);
      toast.error("Failed to save establishment");
    } finally {
      setEstablishmentLoading(false);
    }
  };

  const handleUpdateCommentSubmit = async (values: any) => {
    try {
      setAddUpdateCommentLoading(true);
      if (editingRecord?.id) {
        await dispatch(updateNoteByAdmin({
          lostId: editingRecord.lostId, note: values.note, id: editingRecord.id
        })).unwrap();
        handleCommentCancel();
      }
    } catch (error) {
      console.error("Create sticky error:", error);
      setAddUpdateCommentLoading(false);
    }

  }

  // L&F Contacts handlers
  // The body's "Save Contacts" flow uses its own email-confirmation modal (see
  // handleEmailConfirm below) so the modal's notify checkbox is ignored here —
  // we only accept the arg to match the updated onSave signature.
  const handleBodyLFSave = async (detailsList: LFDepartmentDetails[], _sendEmail: boolean = true) => {
    if (!report?.id || detailsList.length === 0) return;

    // In Review status — save silently, no email, no status change
    if (dataToRender?.status === LostStatuses.Review) {
      setBodyLFLoading(true);
      try {
        const result = await dispatch(updateLFNotifications({
          id: report.id.toString(),
          lfDepartmentDetails: detailsList,
          sendEmail: false,
        })).unwrap();

        const mergedNotifications = [...(report.lfNotifications || []), ...detailsList];
        dispatch(updateReportLFNotifications({ ...report, lfNotifications: mergedNotifications }));
        message.success(result.message || 'L&F contacts saved successfully');
        setShowBodyLFModal(false);

        dispatch(fetchAllLostItemLogs({
          lostId: report.id,
          withDeleted: false,
          keepPaymentLog: isAccessPaymentLogs
        }));
      } catch (error: any) {
        message.error(typeof error === 'string' ? error : 'Failed to save L&F contacts');
      } finally {
        setBodyLFLoading(false);
      }
      return;
    }

    setPendingLFDetails(detailsList);
    // All entries (existing + new) checked by default
    const allCount = (dataToRender?.lfNotifications?.length || 0) + detailsList.length;
    setEmailCheckedIndices(Array.from({ length: allCount }, (_, i) => i));
    setShowBodyLFModal(false);
    setShowEmailConfirmModal(true);
  };

  const handleEmailConfirm = async (sendEmail: boolean) => {
    if (!report?.id || pendingLFDetails.length === 0) return;
    setBodyLFLoading(true);
    try {
      // Build full list to pick selected entries for email
      const allEntries = [...(dataToRender?.lfNotifications || []), ...pendingLFDetails];
      const selectedForEmail = sendEmail ? emailCheckedIndices.map(i => allEntries[i]).filter(Boolean) : undefined;
      const result = await dispatch(updateLFNotifications({
        id: report.id.toString(),
        lfDepartmentDetails: pendingLFDetails,
        sendEmail,
        emailLfDepartmentDetails: selectedForEmail,
      })).unwrap();

      // Update Redux store with merged notifications
      const mergedNotifications = [
        ...(report.lfNotifications || []),
        ...pendingLFDetails
      ];
      const firstEntry = pendingLFDetails[0];
      dispatch(updateReportLFNotifications({
        lfDepartmentName: report.lfDepartmentName || firstEntry.lfDepartmentName,
        lfContactPerson: report.lfContactPerson || firstEntry.lfContactPerson,
        lfContactEmail: report.lfContactEmail || firstEntry.lfContactEmail,
        lfContactPhone: report.lfContactPhone || firstEntry.lfContactPhone,
        lfNotes: report.lfNotes || firstEntry.lfNotes,
        additionalComments: report.additionalComments || firstEntry.additionalComments,
        establishmentName: report.establishmentName || firstEntry.establishmentName,
        lfNotifiedAt: report.lfNotifiedAt || new Date().toISOString(),
        lfNotifications: mergedNotifications,
      }));

      message.success(result.message || 'L&F contacts saved successfully');

      // Refresh activity log
      dispatch(fetchAllLostItemLogs({
        lostId: report.id,
        withDeleted: report.status === LostStatuses.Deleted,
        keepPaymentLog: isAccessPaymentLogs
      }));
    } catch (error: any) {
      message.error(typeof error === 'string' ? error : 'Failed to save L&F contacts');
    } finally {
      setBodyLFLoading(false);
      setShowEmailConfirmModal(false);
      setPendingLFDetails([]);
    }
  };

  const handleLFCommentSave = async (index: number, comment: string, field: string = 'adminComment') => {
    if (!report?.id) return;
    const key = `${index}-${field}`;
    setSavingFields(prev => ({ ...prev, [key]: true }));
    try {
      await dispatch(updateLFNotificationComment({ id: report.id.toString(), index, comment, field })).unwrap();
      const updated = [...(report.lfNotifications || [])];
      if (updated[index]) {
        updated[index] = { ...updated[index], [field]: comment };
        dispatch(updateReportLFNotifications({ ...report, lfNotifications: updated }));
      }
      setSavingFields(prev => { const next = { ...prev }; delete next[key]; return next; });
      setSavedFields(prev => ({ ...prev, [key]: true }));
      setTimeout(() => setSavedFields(prev => { const next = { ...prev }; delete next[key]; return next; }), 2000);
    } catch (error: any) {
      setSavingFields(prev => { const next = { ...prev }; delete next[key]; return next; });
      message.error('Failed to save comment');
    }
  };

  useEffect(() => {
    if (editingRecord) {
      form.setFieldsValue({ ...editingRecord, status: editingRecord.status === ActivationStatus.Active ? false : true })
    }
  }, [editingRecord])

  useEffect(() => {
    if (editingRecord) {
      commentForm.setFieldsValue({ ...editingRecord, status: editingRecord.status === ActivationStatus.Active ? false : true })
    }
  }, [editingRecord])



  const pendingRequestMessage = useMemo(() => {
    if (report?.pendingRequest?.id && report?.pendingRequest?.operation === PendingRequestOperation.Delete) {
      return `Delete request received from ${report?.user?.firstName} ${report?.user?.lastName} on ${convertUtcToLocal(report?.pendingRequest?.createdAt, "MM/DD/YYYY")} at ${convertUtcToLocal(report?.pendingRequest?.createdAt, "HH:mm:ss")}, Reason: ${report?.pendingRequest?.data?.discardReason}`;
    } else if (report?.pendingRequest?.id && report?.pendingRequest?.operation === PendingRequestOperation.Update) {
      return `Update request received from ${report?.user?.firstName} ${report?.user?.lastName} on ${convertUtcToLocal(report?.pendingRequest?.createdAt, "MM/DD/YYYY")} at ${convertUtcToLocal(report?.pendingRequest?.createdAt, "HH:mm:ss")}`;
    } else if (report?.pendingRequest?.id && report?.pendingRequest?.operation === PendingRequestOperation.UpdateShippingInfo) {
      return `Shipping address update request received from ${report?.user?.firstName} ${report?.user?.lastName}. Please review the changes and resend the quote with updated shipping costs.`;
    }
    return "";
  }, [report?.user, report?.pendingRequest]);

  const renderUpdatedField = (currentValue: string, updatedValue?: string, showUpdated: boolean = false) => {
    if (reportPendingRequest?.operation === PendingRequestOperation.Update && updatedValue && currentValue !== updatedValue) {
      if (showUpdated && tabType === "pending") {
        return (
          <>
            <UpdatedText>{updatedValue}</UpdatedText> <StrikethroughText>{currentValue}</StrikethroughText>
          </>
        );
      }
      return currentValue;
    }
    return currentValue;
  };

  const handleUpdateReportDetails = async () => {
    if (report?.id) {
      try {
        const isUrgent = false;
        !isDeleteRequest && await dispatch(updateLostItemIsUrgent({ id: report?.id, isUrgent: false })).unwrap();
        await dispatch(updateTicketLocally({ ticket: convertIntoBoardTicket({ ...report, isUrgent }) }));
      } catch (error) {
      }
    }
  }

  const handleApproveRequest = async () => {
    if (report?.id) {
      let unlinkReason = "";
      if (isDeleteRequest) {
        unlinkReason = await unlinkForm.getFieldValue("unlinkReason");
      }
      setLoading(true);
      try {
        const response = await dispatch(passPendingRequest({ id: report?.id, unlinkReason: unlinkReason, isDeleteRequest: isDeleteRequest })).unwrap();
        if (response) {
          await handleUpdateReportDetails();
          if (reportPendingRequest?.operation === PendingRequestOperation.Delete) {
            toast.success(`Item deleted successfully`);
            //remove from our local data and navigate to report screen
            navigate(SystemPayRoutes.reports);
          } else if (reportPendingRequest?.operation === PendingRequestOperation.Update) {
            toast.success(`Item update passed successfully`);
            //As of now we put this once got the response from api we remove this.
            fetchReport(report?.trackingId.toString());
            // window.location.reload()
          }
          else if (reportPendingRequest?.operation === PendingRequestOperation.UpdateShippingInfo) {
            toast.success(`Shipping address update request passed successfully`);
            //As of now we put this once got the response from api we remove this.
            fetchReport(report?.trackingId.toString());
          }
        }
      } catch (error) {
        console.log({ error });
      } finally {
        setLoading(false);
      }
    }
  };

  const handleDisApproveRequest = async (rejectReason: string) => {
    if (report?.id) {
      setLoading(true);
      try {
        const isUrgent = false;
        const response = await dispatch(rejectPendingRequest({ id: report?.id, rejectReason })).unwrap();
        if (response) {
          await dispatch(updateTicketLocally({ ticket: convertIntoBoardTicket({ ...report, isUrgent }) }));
        }
      } catch (error) {
        console.log({ error });
      } finally {
        setLoading(false);
      }
    }
  };

  const succeededPayment = useMemo(() => {
    return report?.payment?.find((payment) => payment.status === PaymentStatus.Succeeded);
  }, [report?.payment]);

  const isPaymentSucceeded = !!succeededPayment;

  // Refund detection — once a customer requests a refund the original payment row flips
  // from Succeeded → Refunded. Used to swap "you have time" warnings into a "refund already
  // requested" message so admins don't waste effort progressing a claim that's been refunded.
  const refundedPayment = useMemo(() => {
    return report?.payment?.find((payment) => payment.status === PaymentStatus.Refunded);
  }, [report?.payment]);

  const isRefundRequested = !!refundedPayment;

  // Time between when the claim was reported (report.createdAt) and when the refund was
  // requested (payment.updatedAt at the time of the Refunded status flip). This tells admins
  // how fast the customer changed their mind — useful context for fraud / abuse review.
  const timeFromReportToRefund = useMemo(() => {
    if (!refundedPayment?.updatedAt || !report?.createdAt) return null;
    const elapsedMs = new Date(refundedPayment.updatedAt).getTime() - new Date(report.createdAt).getTime();
    if (elapsedMs < 0) return null;
    const totalMinutes = Math.floor(elapsedMs / (60 * 1000));
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;
  }, [refundedPayment?.updatedAt, report?.createdAt]);

  const paymentSucceededReceipt = useMemo(() => {
    return report?.paymentReceipt?.find((payment) => payment?.fullUrl);
  }, [report?.paymentReceipt]);

  // Refund-window countdown — fixed at 24 hours by business rule (independent of the
  // configurable "Recent Payment Highlight" setting which only drives the kanban visuals).
  // Returns null when no succeeded payment or once the 24h window has lapsed.
  const REFUND_WINDOW_HOURS = 24;
  const refundWindowRemaining = useMemo(() => {
    if (!succeededPayment?.createdAt) return null;
    const ageMs = Date.now() - new Date(succeededPayment.createdAt).getTime();
    const remainingMs = REFUND_WINDOW_HOURS * 60 * 60 * 1000 - ageMs;
    if (remainingMs <= 0) return null;
    const totalMinutes = Math.floor(remainingMs / (60 * 1000));
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;
  }, [succeededPayment?.createdAt]);

  const handleTabChange = async (activeKey: string) => {
    if (activeKey.startsWith("version-")) {
      setTabType("version");
      const version = parseInt(activeKey.split("-")[1]);
      if (report?.id) {
        try {
          const response = await dispatch(
            getReportVersionAsyncThunk({
              trackingId: report.id,
              version,
              withDeleted: report.status === LostStatuses.Deleted
            })
          ).unwrap();
          setActiveData(response);
        } catch (error) {
          console.error("Failed to fetch version:", error);
        }
      }
    } else if (activeKey === "original") {
      setTabType("original");
      if ((report?.versionCount ?? 0) > 1) {
        if (report?.id) {
          try {
            const response = await dispatch(
              getReportVersionAsyncThunk({
                trackingId: report.id,
                version: 0,
                withDeleted: report.status === LostStatuses.Deleted
              })
            ).unwrap();
            setActiveData(response);
          } catch (error) {
            console.error("Failed to fetch original version:", error);
          }
        }
      }
    } else if (activeKey === "latest") {
      setTabType("latest");
      setActiveData(report);
    } else if (activeKey === "pending") {
      setTabType("pending");
      setActiveData(report);
    }

    // Clear version data when switching to non-version tabs
    if (!activeKey.startsWith("version-") && activeKey !== "original") {
      dispatch(clearVersionData());
    }
  };

  const buildAddress = (user: User | undefined): React.ReactNode => {
    if (!user) {
      return notAvailable;
    }

    // US format: Address1, Address2 (on separate lines), City, State ZIP, Country
    const addressLines: { text: string; copyText: string }[] = [];

    if (user.address1) addressLines.push({ text: user.address1, copyText: user.address1 });
    if (user.address2) addressLines.push({ text: user.address2, copyText: user.address2 });

    // City, State ZIP on one line — each individually copyable
    const cityStateParts: { text: string; copyText: string; separator: string }[] = [];
    if (user.city) cityStateParts.push({ text: user.city, copyText: user.city, separator: ' ' });
    if (user.state) cityStateParts.push({ text: user.state, copyText: user.state, separator: ' ' });
    if (user.zip) cityStateParts.push({ text: user.zip, copyText: user.zip, separator: '' });

    if (!addressLines.length && !cityStateParts.length && !user.country) return notAvailable;

    return (
      <>
        {addressLines.map((line, index) => (
          <React.Fragment key={index}>
            <CopyToClipboard text={line.copyText}>{line.text}</CopyToClipboard>
            <br />
          </React.Fragment>
        ))}
        {cityStateParts.length > 0 && (
          <>
            <span>
              {cityStateParts.map((part, i) => (
                <React.Fragment key={i}>
                  <CopyToClipboard text={part.copyText}>{part.text}</CopyToClipboard>
                  {i < cityStateParts.length - 1 && part.separator}
                </React.Fragment>
              ))}
            </span>
            {user.country && <br />}
          </>
        )}
        {user.country && <CopyToClipboard text={user.country}>{user.country}</CopyToClipboard>}
      </>
    );
  };

  // Plain text version for copying - 3 lines format
  const buildAddressText = (user: User | undefined): string => {
    if (!user) return '';

    const lines: string[] = [];

    // Line 1: Address 1 and Address 2
    const addressLine = [user.address1, user.address2].filter(Boolean).join(', ');
    if (addressLine) lines.push(addressLine);

    // Line 2: City, State ZIP
    const cityStateZip = [
      user.city,
      [user.state, user.zip].filter(Boolean).join(' ')
    ].filter(Boolean).join(', ');
    if (cityStateZip) lines.push(cityStateZip);

    // Line 3: Country
    if (user.country) lines.push(user.country);

    return lines.join('\n');
  };

  const formatLostTimeLabel = (value?: string | null) => {
    if (!value) {
      return '';
    }

    return value.charAt(0).toUpperCase() + value.slice(1);
  };

  const showPreMatchFoundItem = useMemo(() => {
    return ((preMatchedFoundItems && preMatchedFoundItems?.length > 0) && ((report?.status && report?.status >= LostStatuses.InProcess && !shipMatchEnabled) || (shipMatchEnabled && report?.status))) || report?.foundItem?.id;
  }, [report, preMatchedFoundItems, shipMatchEnabled]);

  const isDeleteStatus = useMemo(() => report?.status === LostStatuses.Deleted, [report?.status]);

  const latestUpdatedReportDocument = useMemo(() => {
    if (report?.lostReport && report?.lostReport?.length > 0) {
      return findLatestDocument(report?.lostReport);
    }
    return null;
  }, [report?.lostReport])

  const renderContent = (showUpdated: boolean = false, contentTabType: "latest" | "pending" | "original" | "version" = "original") => {
    const dataToRender = activeData || report;
    const versionCount = dataToRender?.versionCount ?? 0;
    const updateEstablishmentTypeData = dataToRender?.establishmentType && dataToRender?.pendingRequest?.data?.establishmentType && mergePendingIntoOriginal(dataToRender?.establishmentType, dataToRender?.pendingRequest?.data?.establishmentType);

    const shouldShowEditButtons = contentTabType === "latest" || (contentTabType === "original" && versionCount <= 1 && !reportPendingRequest?.id);

    const handleStickyModalOpen = (type: "add" | "update", item: any) => {
      setStickyModalType(type);
      setEditingRecord(item);
      setIsMarkModalOpen(true);
    };

    const handleEditNoteModalOpen = (type: "add" | "update", item: any) => {
      setEditingRecord(item);
      setIsEditNoteModalOpen(true);
    };

    const isDisabledContent = (isDeleteRequest && contentTabType === "pending") || contentTabType === "version" || (versionCount > 1 && contentTabType === "original");

    const renderUpdatedFieldInContent = (currentValue: React.ReactNode, updatedValue?: React.ReactNode, showUpdated: boolean = false) => {
      if ((reportPendingRequest?.operation === PendingRequestOperation.Update || reportPendingRequest?.operation === PendingRequestOperation.UpdateShippingInfo) && updatedValue && currentValue !== updatedValue) {
        if (showUpdated && contentTabType === "pending") {
          return (
            <>
              <UpdatedText>{updatedValue}</UpdatedText> <StrikethroughText>{currentValue}</StrikethroughText>
            </>
          );
        }
        return currentValue;
      }
      return currentValue;
    };

    // Use actual items from the report data, fallback to single item structure for backward compatibility
    let items: any[] = dataToRender?.items?.length ? dataToRender.items : [
      {
        id: dataToRender?.id || '',
        itemDescription: dataToRender?.itemDescription || '',
        deletedAt: null,
        createdAt: dataToRender?.createdAt || '',
        updatedAt: dataToRender?.updatedAt || '',
        category: dataToRender?.category || { id: '', name: '', status: 0, deletedAt: null, createdAt: '', updatedAt: '' },
        subCategory: dataToRender?.subCategory || {
          id: '',
          name: '',
          status: 0,
          deletedAt: null,
          createdAt: '',
          updatedAt: '',
          questions: [],
          category: dataToRender?.category || { id: '', name: '', status: 0, deletedAt: null, createdAt: '', updatedAt: '' }
        },
        documents: dataToRender?.documents || [],
        lostDate: dataToRender?.lostDate
      }
    ];

    const filterNewItemsInPendingRequest = dataToRender?.pendingRequest?.data?.items?.filter((item) => item?.isNew);

    if (filterNewItemsInPendingRequest && showUpdated && filterNewItemsInPendingRequest?.length > 0) {
      items = [...items, ...filterNewItemsInPendingRequest];
    }

    // Find deleted items by comparing original items with pending request items
    if (isUpdateRequest && dataToRender?.pendingRequest?.data?.items) {
      const pendingItemIds = dataToRender.pendingRequest.data.items.map(item => item.id);
      const deletedItems = items.filter(item => !pendingItemIds.includes(item.id));

      // Mark deleted items with deletedAt flag for badge display
      items = items.map(item => {
        const isDeleted = deletedItems.some(deletedItem => deletedItem.id === item.id);
        if (isDeleted) {
          return { ...item, deletedAt: new Date().toISOString() };
        }
        return item;
      });
    }


    return (
      <DisabledContent isDeleting={isDisabledContent}>
        <Row gutter={12}>
          <StyledCol xs={24} sm={12} lg={7} xl={7}>
            <CardWrapper title="Personal information">
              {isLoading ? (
                <Skeleton paragraph={{ rows: 5 }} active />
              ) : (
                <>
                  <FlexWrapper>
                    <SubItemIcon>
                      <UserRound />
                    </SubItemIcon>
                    <SubItemText style={{ textTransform: 'uppercase', fontWeight: 600 }}>
                      <CopyToClipboard text={dataToRender?.user?.firstName}>
                        {showUpdated && dataToRender?.pendingRequest?.data?.user?.firstName && dataToRender?.pendingRequest?.data?.user?.firstName !== dataToRender?.user?.firstName ? (
                          <>
                            <StrikethroughText>{dataToRender?.user?.firstName}</StrikethroughText>
                            <UpdatedText>{dataToRender?.pendingRequest?.data?.user?.firstName}</UpdatedText>
                          </>
                        ) : (
                          dataToRender?.user?.firstName
                        )}
                      </CopyToClipboard>
                      {' '}
                      <CopyToClipboard text={dataToRender?.user?.lastName}>
                        {showUpdated && dataToRender?.pendingRequest?.data?.user?.lastName && dataToRender?.pendingRequest?.data?.user?.lastName !== dataToRender?.user?.lastName ? (
                          <>
                            <StrikethroughText>{dataToRender?.user?.lastName}</StrikethroughText>
                            <UpdatedText>{dataToRender?.pendingRequest?.data?.user?.lastName}</UpdatedText>
                          </>
                        ) : (
                          dataToRender?.user?.lastName
                        )}
                      </CopyToClipboard>
                    </SubItemText>
                  </FlexWrapper>
                  {(dataToRender?.user?.phone || dataToRender?.pendingRequest?.data?.user?.phone) && (
                    <FlexWrapper>
                      <SubItemIcon>
                        <PhoneOneIcon />
                      </SubItemIcon>
                      <SubItemText>
                        <CopyToClipboard text={dataToRender?.user?.phone}>
                          {renderUpdatedFieldInContent(dataToRender?.user?.phone, dataToRender?.pendingRequest?.data?.user?.phone, showUpdated)}
                        </CopyToClipboard>
                      </SubItemText>
                    </FlexWrapper>
                  )}
                  {/* {dataToRender?.user?.phone2 && (
                    <FlexWrapper>
                      <SubItemIcon>
                        <PhoneTwoIcon />
                      </SubItemIcon>
                      <SubItemText>{renderUpdatedFieldInContent(dataToRender?.user?.phone2 ?? notAvailable, dataToRender?.pendingRequest?.data?.user?.phone2, showUpdated)}</SubItemText>
                    </FlexWrapper>
                  )} */}
                  {(dataToRender?.user?.email || dataToRender?.pendingRequest?.data?.user?.email) && (
                    <FlexWrapper>
                      <SubItemIcon>
                        <EnvelopeOpenOneIcon />
                      </SubItemIcon>
                      <SubItemText>
                        <CopyToClipboard text={dataToRender?.user?.email}>
                          {renderUpdatedFieldInContent(dataToRender?.user?.email, dataToRender?.pendingRequest?.data?.user?.email, showUpdated)}
                        </CopyToClipboard>
                      </SubItemText>
                    </FlexWrapper>
                  )}
                  {/* internalEmail hidden from admin dashboard */}
                  {(dataToRender?.user?.address1 || dataToRender?.user?.city || dataToRender?.user?.state || dataToRender?.user?.country || dataToRender?.pendingRequest?.data?.user?.address1) && (
                    <FlexWrapper>
                      <SubItemIcon>
                        <EnvironmentOutlined />
                      </SubItemIcon>
                      <SubItemText style={{ textTransform: 'uppercase' }}>
                        {showUpdated && dataToRender?.pendingRequest?.data?.user ? (
                          <>
                            <div style={{ textDecoration: 'line-through', color: '#999' }}>
                              {buildAddress(dataToRender?.user)}
                            </div>
                            <div style={{ color: '#52c41a' }}>
                              {buildAddress(dataToRender?.pendingRequest?.data?.user)}
                            </div>
                          </>
                        ) : (
                          buildAddress(dataToRender?.user)
                        )}
                      </SubItemText>
                    </FlexWrapper>
                  )}

                </>
              )}
            </CardWrapper>

          </StyledCol>

          <StyledCol xs={24} sm={12} lg={7} xl={7}>
            <ReportDetailsCart title="Item Details">
              {isLoading ? (
                <div style={{ padding: "16px" }}>
                  <Skeleton paragraph={{ rows: 2 }} active />
                  <div style={{ marginTop: "16px" }}>
                    <Skeleton paragraph={{ rows: 3 }} active />
                  </div>
                  <div style={{ marginTop: "16px" }}>
                    <Skeleton paragraph={{ rows: 2 }} active />
                  </div>
                  <div style={{ marginTop: "16px", display: "flex", gap: "8px" }}>
                    <Skeleton.Image style={{ width: 80, height: 80 }} />
                    <Skeleton.Image style={{ width: 80, height: 80 }} />
                    <Skeleton.Image style={{ width: 80, height: 80 }} />
                  </div>
                </div>
              ) : (
                <CustomCollapse
                  defaultActiveKey={["0"]}
                  expandIcon={({ isActive }) => (
                    <CaretRightOutlined rotate={isActive ? 90 : 0} />
                  )}
                >
                  {items?.map((item: any, index: number) => {
                    const updateItem: any = isUpdateRequest && dataToRender?.pendingRequest?.data?.items?.length ? dataToRender?.pendingRequest?.data?.items?.find((i: any) => i.id === item.id) : null;
                    const updateSubCategoryData = updateItem?.subCategory && updateItem?.subCategory && mergePendingIntoOriginal(item?.subCategory, updateItem?.subCategory);
                    return (
                      <Collapse.Panel
                        key={index}
                        header={
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <BoxIcon />
                            <span style={{ fontWeight: 500 }}>{item?.category?.name || `Item ${index + 1}`}</span>
                            {item?.isNew && (
                              <NewItemBadge count="✨ Newly Added" />
                            )}
                            {(item?.deletedAt || updateItem?.deletedAt) && showUpdated && (
                              <DeletedItemBadge count="🗑️ Deleted" />
                            )}
                          </div>
                        }
                      >
                        {isLoading ? (
                          <>
                            <Skeleton paragraph={{ rows: 6 }} active />
                            <Skeleton.Image style={{ width: 100, height: 100 }} />
                            <Skeleton.Image style={{ width: 100, height: 100 }} />
                            <Skeleton.Image style={{ width: 100, height: 100 }} />
                          </>
                        ) : (
                          <>
                            <FlexWrapper>
                              <SubItemIcon>
                                <BoxIcon />
                              </SubItemIcon>
                              <SubItemText>Category: <CopyToClipboard text={item?.category?.name}>{renderUpdatedFieldInContent(item?.category?.name || "N/A", updateItem?.category?.name, showUpdated)}</CopyToClipboard></SubItemText>
                            </FlexWrapper>

                            {item?.subCategory?.name && (
                              <FlexWrapper>
                                <SubItemIcon>
                                  <IconWrapper>
                                    <SubBoxIcon />
                                  </IconWrapper>
                                </SubItemIcon>
                                <SubItemText>Sub Category: <CopyToClipboard text={item?.subCategory?.name}>{renderUpdatedFieldInContent(item.subCategory.name, updateItem?.subCategory?.name, showUpdated)}</CopyToClipboard></SubItemText>
                              </FlexWrapper>
                            )}

                            {/* Questions with proper field type handling */}
                            {isUpdateRequest && updateSubCategoryData ? <>
                              {sortByDate(updateSubCategoryData?.questions || [], "createdAt")?.map((question: any) => {
                                switch (question.fieldType) {
                                  case 1:
                                    const answerValue1 = question?.answers?.answer === "true" ? "Yes" : question?.answers?.answer === "false" ? "No" : question?.answers === null ? "N/A" : question?.answers?.answer;
                                    return (
                                      <FlexWrapper key={question.id}>
                                        <SubItemIcon>
                                          <IconWrapper>
                                            <SubBoxIcon />
                                          </IconWrapper>
                                        </SubItemIcon>
                                        <SubItemText>{question?.fieldName} :</SubItemText>
                                        <SubItemText>
                                          <CopyToClipboard text={answerValue1}>
                                            {renderUpdatedFieldInContent(
                                              question?.answers?.previousAnswer === "true" ? "Yes" :
                                                question?.answers?.previousAnswer === "false" ? "No" :
                                                  question?.answers === null ? "N/A" :
                                                    question?.answers?.previousAnswer,
                                              answerValue1,
                                              showUpdated
                                            )}
                                          </CopyToClipboard>
                                        </SubItemText>
                                      </FlexWrapper>
                                    );
                                  case 2:
                                    const selectedCheckBox: any = question?.options?.find((option: any) => option.name === question?.answers?.answer);
                                    const answerValue2 = question?.answers?.answer === "true" ? "Yes" : question?.answers?.answer === "false" ? "No" : question?.answers === null ? "No" : question?.answers?.answer;
                                    return (
                                      <div key={question.id}>
                                        <FlexWrapper>
                                          <SubItemIcon>
                                            <IconWrapper>
                                              <SubBoxIcon />
                                            </IconWrapper>
                                          </SubItemIcon>
                                          <SubItemText>{question?.fieldName} :</SubItemText>
                                          <SubItemText>
                                            <CopyToClipboard text={answerValue2}>
                                              {renderUpdatedFieldInContent(
                                                question?.answers?.previousAnswer === "true" ? "Yes" :
                                                  question?.answers?.previousAnswer === "false" ? "No" :
                                                    question?.answers === null ? "N/A" :
                                                      question?.answers?.previousAnswer,
                                                answerValue2,
                                                showUpdated
                                              )}
                                            </CopyToClipboard>
                                          </SubItemText>
                                        </FlexWrapper>
                                        {(sortByDate(selectedCheckBox?.subQuestion, "createdAt"))?.map((subQ: any) => {
                                          return (
                                            <FlexWrapper key={subQ.id}>
                                              <SubItemIcon>
                                                <IconWrapper>
                                                  <SubBoxIcon />
                                                </IconWrapper>
                                              </SubItemIcon>
                                              <SubItemText>{subQ?.fieldName} :</SubItemText>
                                              <SubItemText>
                                                <CopyToClipboard text={subQ?.answers?.answer}>
                                                  {renderUpdatedFieldInContent(
                                                    subQ?.answers?.previousAnswer,
                                                    subQ?.answers?.answer,
                                                    showUpdated
                                                  )}
                                                </CopyToClipboard>
                                              </SubItemText>
                                            </FlexWrapper>
                                          );
                                        })}
                                      </div>
                                    );
                                  case 3:
                                    const optionsToSearch1 = question?.dynamicOptions || question?.options || [];
                                    const selectedOptionBrand: any = optionsToSearch1.find((option: any) => (option.id === question?.answers?.answer) || (option.name === question?.answers?.answer));
                                    const displayValue1 = selectedOptionBrand
                                      ? (selectedOptionBrand.code ? `${selectedOptionBrand.name} - ${selectedOptionBrand.code}` : selectedOptionBrand.name)
                                      : (question?.answers?.answer === "true" ? "Yes" : question?.answers?.answer === "false" ? "No" : question?.answers === null ? "N/A" : question?.answers?.answer);
                                    const previousDisplayValue1 = question?.answers?.previousAnswer === "true" ? "Yes" :
                                      question?.answers?.previousAnswer === "false" ? "No" :
                                        question?.answers === null ? "N/A" :
                                          question?.answers?.previousAnswer;
                                    return (
                                      <div key={question.id}>
                                        <FlexWrapper>
                                          <SubItemIcon>
                                            <IconWrapper>
                                              <SubBoxIcon />
                                            </IconWrapper>
                                          </SubItemIcon>
                                          <SubItemText>{question?.fieldName} :</SubItemText>
                                          <SubItemText>
                                            {question?.dynamicOptions && question?.dynamicOptions?.length > 0 ? (
                                              selectedOptionBrand ? (
                                                <EstablishmentPopover
                                                  establishment={selectedOptionBrand}
                                                  onManage={selectedOptionBrand?.id ? () => handleManageEstablishment(selectedOptionBrand.id) : undefined}
                                                >
                                                  <span style={{
                                                    color: '#1890ff',
                                                    fontWeight: 'bold',
                                                    cursor: 'pointer'
                                                  }}>
                                                    {renderUpdatedFieldInContent(
                                                      previousDisplayValue1,
                                                      displayValue1,
                                                      showUpdated
                                                    )}
                                                    <ContactsOutlined style={{ marginLeft: 8 }} />
                                                  </span>
                                                </EstablishmentPopover>
                                              ) : (
                                                <span>
                                                  {renderUpdatedFieldInContent(
                                                    previousDisplayValue1,
                                                    displayValue1,
                                                    showUpdated
                                                  )}
                                                  {question?.EstablishmentType?.id && (
                                                    <Button
                                                      type="link"
                                                      size="small"
                                                      icon={<PlusOutlined />}
                                                      onClick={() => handleAddEstablishment(question.EstablishmentType.id)}
                                                      style={{ marginLeft: 8, padding: 0 }}
                                                    >
                                                      Add Establishment
                                                    </Button>
                                                  )}
                                                </span>
                                              )
                                            ) : (
                                              <span>
                                                {renderUpdatedFieldInContent(
                                                  previousDisplayValue1,
                                                  displayValue1,
                                                  showUpdated
                                                )}
                                              </span>
                                            )}
                                          </SubItemText>
                                        </FlexWrapper>
                                        {(sortByDate(selectedOptionBrand?.subQuestion, "createdAt"))?.map((subQ: any) => {
                                          return (
                                            <FlexWrapper key={subQ.id}>
                                              <SubItemIcon>
                                                <IconWrapper>
                                                  <SubBoxIcon />
                                                </IconWrapper>
                                              </SubItemIcon>
                                              <SubItemText>{subQ?.fieldName} :</SubItemText>
                                              <SubItemText>{renderUpdatedFieldInContent(
                                                subQ?.answers?.answer,
                                                "",
                                                showUpdated
                                              )}</SubItemText>
                                            </FlexWrapper>
                                          );
                                        })}
                                      </div>
                                    );
                                  default:
                                    return null;
                                }
                              })}
                            </> : <>
                              {(() => {
                                const sortedQs = sortByDate(item?.subCategory?.questions || [], "createdAt") || [];
                                const isBooleanQ = (q: any) => {
                                  if (q?.answers === null || !q?.answers?.answer) return false;
                                  if (q.answers.answer !== "true" && q.answers.answer !== "false") return false;
                                  // Hide unchecked/blank checkboxes (answer "false" means left blank/unchecked)
                                  if (q.answers.answer === "false") return false;
                                  if (q.fieldType === 2) {
                                    const selOpt: any = q?.options?.find((o: any) => o.name === q.answers.answer);
                                    if (selOpt?.subQuestion?.length) return false;
                                  }
                                  return q.fieldType === 1 || q.fieldType === 2;
                                };
                                const boolQs = sortedQs.filter((q: any) => {
                                  const pendingA = updateItem?.subCategory?.questions?.find((uq: any) => uq.fieldName === q?.fieldName)?.answers?.answer;
                                  if (q?.answers === null && !pendingA) return false;
                                  if (!q?.answers?.answer && q?.answers?.answer !== false && !pendingA) return false;
                                  return isBooleanQ(q);
                                });
                                const otherQs = sortedQs.filter((q: any) => {
                                  if (boolQs.includes(q)) return false;
                                  // Also hide unchecked boolean checkboxes from the regular list
                                  if ((q.fieldType === 1 || q.fieldType === 2) && q?.answers?.answer === "false") return false;
                                  return true;
                                });
                                return (
                                  <>
                                    {boolQs.length > 0 && (
                                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '2px 16px', margin: '6px 0', fontSize: 14, lineHeight: '24px' }}>
                                        {boolQs.map((q: any) => (
                                          <span key={q.id}>
                                            <span style={{ color: '#666' }}>{q.fieldName}:</span>{' '}
                                            {q.answers.answer === "true" ? "Yes" : "No"}
                                          </span>
                                        ))}
                                      </div>
                                    )}
                                    {otherQs.map((question: any) => {
                                      const pendingItemAnswer = updateItem?.subCategory?.questions?.find((q: any) => q.fieldName === question?.fieldName)?.answers?.answer;
                                      if (question?.answers === null && !pendingItemAnswer) return null;
                                      if (!question?.answers?.answer && question?.answers?.answer !== false && !pendingItemAnswer) return null;
                                      switch (question.fieldType) {
                                        case 1:
                                          const answerVal1 = question?.answers?.answer === "true" ? "Yes" :
                                            question?.answers?.answer === "false" ? "No" :
                                                question?.answers?.answer;
                                          return (
                                            <FlexWrapper key={question.id}>
                                              <SubItemIcon>
                                                <IconWrapper>
                                                  <SubBoxIcon />
                                                </IconWrapper>
                                              </SubItemIcon>
                                              <SubItemText>{question?.fieldName} :</SubItemText>
                                              <SubItemText>
                                                <CopyToClipboard text={answerVal1}>
                                                  {renderUpdatedFieldInContent(
                                                    answerVal1,
                                                    pendingItemAnswer,
                                                    showUpdated
                                                  )}
                                                </CopyToClipboard>
                                              </SubItemText>
                                            </FlexWrapper>
                                          );
                                        case 2:
                                          const selectedCheckBox: any = question?.options?.find((option: any) => option.name === question?.answers?.answer);
                                          const answerVal2 = question?.answers?.answer === "true" ? "Yes" :
                                            question?.answers?.answer === "false" ? "No" :
                                                question?.answers?.answer;
                                          return (
                                            <div key={question.id}>
                                              <FlexWrapper>
                                                <SubItemIcon>
                                                  <IconWrapper>
                                                    <SubBoxIcon />
                                                  </IconWrapper>
                                                </SubItemIcon>
                                                <SubItemText>{question?.fieldName} :</SubItemText>
                                                <SubItemText>
                                                  <CopyToClipboard text={answerVal2}>
                                                    {renderUpdatedFieldInContent(
                                                      answerVal2,
                                                      pendingItemAnswer,
                                                      showUpdated
                                                    )}
                                                  </CopyToClipboard>
                                                </SubItemText>
                                              </FlexWrapper>
                                              {(sortByDate(selectedCheckBox?.subQuestion, "createdAt"))?.map((subQ: any) => {
                                                return (
                                                  <FlexWrapper key={subQ.id}>
                                                    <SubItemIcon>
                                                      <IconWrapper>
                                                        <SubBoxIcon />
                                                      </IconWrapper>
                                                    </SubItemIcon>
                                                    <SubItemText>{subQ?.fieldName} :</SubItemText>
                                                    <SubItemText>
                                                      <CopyToClipboard text={subQ?.answers?.answer}>
                                                        {renderUpdatedFieldInContent(
                                                          subQ?.answers?.answer,
                                                          "",
                                                          showUpdated
                                                        )}
                                                      </CopyToClipboard>
                                                    </SubItemText>
                                                  </FlexWrapper>
                                                );
                                              })}
                                            </div>
                                          );
                                  case 3:
                                    const optionsToSearch2 = question?.dynamicOptions || question?.options || [];
                                    const selectedOptionBrand: any = optionsToSearch2.find((option: any) => (option.id === question?.answers?.answer) || (option.name === question?.answers?.answer));
                                    const displayValue2 = question?.answers?.answer === "true" ? "Yes" :
                                      question?.answers?.answer === "false" ? "No" :
                                          selectedOptionBrand ? (selectedOptionBrand.code ? `${selectedOptionBrand.name} - ${selectedOptionBrand.code}` : selectedOptionBrand.name) : question?.answers?.answer;
                                    return (
                                      <div key={question.id}>
                                        <FlexWrapper>
                                          <SubItemIcon>
                                            <IconWrapper>
                                              <SubBoxIcon />
                                            </IconWrapper>
                                          </SubItemIcon>
                                          <SubItemText>{question?.fieldName} :</SubItemText>
                                          <SubItemText>
                                            {question?.dynamicOptions && question?.dynamicOptions?.length > 0 ? (
                                              selectedOptionBrand ? (
                                                <EstablishmentPopover
                                                  establishment={selectedOptionBrand}
                                                  onManage={selectedOptionBrand?.id ? () => handleManageEstablishment(selectedOptionBrand.id) : undefined}
                                                >
                                                  <span style={{
                                                    color: '#1890ff',
                                                    fontWeight: 'bold',
                                                    cursor: 'pointer'
                                                  }}>
                                                    {renderUpdatedFieldInContent(
                                                      displayValue2,
                                                      updateItem?.subCategory?.questions?.find((q: any) => q.fieldName === question?.fieldName)?.answers?.answer,
                                                      showUpdated
                                                    )}
                                                    <ContactsOutlined style={{ marginLeft: 8 }} />
                                                  </span>
                                                </EstablishmentPopover>
                                              ) : (
                                                <span>
                                                  {renderUpdatedFieldInContent(
                                                    displayValue2,
                                                    updateItem?.subCategory?.questions?.find((q: any) => q.fieldName === question?.fieldName)?.answers?.answer,
                                                    showUpdated
                                                  )}
                                                  {question?.EstablishmentType?.id && (
                                                    <Button
                                                      type="link"
                                                      size="small"
                                                      icon={<PlusOutlined />}
                                                      onClick={() => handleAddEstablishment(question.EstablishmentType.id)}
                                                      style={{ marginLeft: 8, padding: 0 }}
                                                    >
                                                      Add Establishment
                                                    </Button>
                                                  )}
                                                </span>
                                              )
                                            ) : (
                                              <span>
                                                {renderUpdatedFieldInContent(
                                                  displayValue2,
                                                  updateItem?.subCategory?.questions?.find((q: any) => q.fieldName === question?.fieldName)?.answers?.answer,
                                                  showUpdated
                                                )}
                                              </span>
                                            )}
                                          </SubItemText>
                                        </FlexWrapper>
                                        {(sortByDate(selectedOptionBrand?.subQuestion, "createdAt"))?.map((subQ: any) => {
                                          return (
                                            <FlexWrapper key={subQ.id}>
                                              <SubItemIcon>
                                                <IconWrapper>
                                                  <SubBoxIcon />
                                                </IconWrapper>
                                              </SubItemIcon>
                                              <SubItemText>{subQ?.fieldName} :</SubItemText>
                                              <SubItemText>{renderUpdatedFieldInContent(
                                                subQ?.answers?.answer,
                                                "",
                                                showUpdated
                                              )}</SubItemText>
                                            </FlexWrapper>
                                          );
                                        })}
                                      </div>
                                    );
                                        default:
                                          return null;
                                      }
                                    })}
                                  </>
                                );
                              })()}
                            </>}

                            {(item?.itemDescription || updateItem?.itemDescription) && (
                              <FlexWrapper>
                                <SubItemIcon>
                                  <IconWrapper>
                                    <SubBoxIcon />
                                  </IconWrapper>
                                </SubItemIcon>
                                <SubItemText>Describe any specific details:</SubItemText>
                                <SubItemText><CopyToClipboard text={item?.itemDescription}>{renderUpdatedFieldInContent(item?.itemDescription, updateItem?.itemDescription, showUpdated)}</CopyToClipboard></SubItemText>
                              </FlexWrapper>
                            )}

                            <FlexWrapper>
                              <SubItemIcon>
                                <IconWrapper>
                                  <SubBoxIcon />
                                </IconWrapper>
                              </SubItemIcon>
                              <SubItemText>Images:</SubItemText>
                            </FlexWrapper>
                            <ImageContainer isActive={!!item?.documents?.length || !!updateItem?.documents?.length}>
                              {(item?.documents?.length || updateItem?.documents?.length) ? (
                                <Images id={item.id} documents={item.documents || []} updatedDocuments={showUpdated ? updateItem?.documents : []} showUpdated={showUpdated} />
                              ) : (
                                <p>No images found</p>
                              )}
                            </ImageContainer>
                          </>
                        )}
                      </Collapse.Panel>
                    )
                  })}
                </CustomCollapse>
              )}
            </ReportDetailsCart>
          </StyledCol>
          <StyledCol xs={24} sm={24} lg={10} xl={10}>
            <CardWrapper title="Location Details">
              {isLoading ? (
                <Skeleton paragraph={{ rows: 6 }} active />
              ) : (
                <>
                  {dataToRender?.establishmentType?.id && (
                    <FlexWrapper>
                      <SubItemIcon>
                        <IconWrapper>
                          <BoxIcon />
                        </IconWrapper>
                      </SubItemIcon>
                      <SubItemText>Establishment Type : </SubItemText>
                      <SubItemText><CopyToClipboard text={dataToRender?.establishmentType?.name}>{renderUpdatedFieldInContent(dataToRender?.establishmentType?.name, dataToRender?.pendingRequest?.data?.establishmentType?.name, showUpdated)}</CopyToClipboard></SubItemText>
                    </FlexWrapper>
                  )}
                  {(dataToRender?.lostDate || dataToRender?.lostTime) && (
                    <FlexWrapper>
                      <SubItemIcon>
                        <IconWrapper>
                          <DistanceIcon />
                        </IconWrapper>
                      </SubItemIcon>
                      <SubItemText>Lost Date :</SubItemText>
                      <SubItemText>
                        <CopyToClipboard text={dataToRender?.lostDate ? convertUtcToLocal(dataToRender.lostDate, "MM/DD/YYYY") : undefined}>
                          {showUpdated && dataToRender?.pendingRequest?.data?.lostDate && dataToRender?.pendingRequest?.data?.lostDate !== dataToRender?.lostDate ? (
                            <>
                              <StrikethroughText>{dataToRender?.lostDate ? convertUtcToLocal(dataToRender.lostDate, "MM/DD/YYYY") : notAvailable}</StrikethroughText>
                              <UpdatedText>{convertUtcToLocal(dataToRender.pendingRequest.data.lostDate, "MM/DD/YYYY")}</UpdatedText>
                            </>
                          ) : (
                            dataToRender?.lostDate ? convertUtcToLocal(dataToRender.lostDate, "MM/DD/YYYY") : notAvailable
                          )}
                        </CopyToClipboard>
                        {dataToRender?.lostTime && (
                          <>
                            {" • "}
                            {showUpdated && dataToRender?.pendingRequest?.data?.lostTime && dataToRender?.pendingRequest?.data?.lostTime !== dataToRender?.lostTime ? (
                              <>
                                <StrikethroughText>{formatLostTimeLabel(dataToRender.lostTime)}</StrikethroughText>
                                <UpdatedText>{formatLostTimeLabel(dataToRender.pendingRequest.data.lostTime)}</UpdatedText>
                              </>
                            ) : (
                              formatLostTimeLabel(dataToRender.lostTime)
                            )}
                          </>
                        )}
                      </SubItemText>
                    </FlexWrapper>
                  )}
                  {isUpdateRequest && updateEstablishmentTypeData ? <>
                    {(sortByDate(updateEstablishmentTypeData?.questions, "createdAt"))?.map((question: any) => {
                      switch (question.fieldType) {
                        case 1:
                          const case1PrevAnswer = question?.answers?.previousAnswer;
                          const case1Answer = question?.answers?.answer;
                          const isCase1Boolean = case1PrevAnswer === "true" || case1PrevAnswer === "false" || case1Answer === "true" || case1Answer === "false";
                          const case1PrevDisplay = case1PrevAnswer === "true" ? "Yes" : case1PrevAnswer === "false" ? "No" : question?.answers === null ? "N/A" : case1PrevAnswer;
                          const case1Display = case1Answer === "true" ? "Yes" : case1Answer === "false" ? "No" : question?.answers === null ? "N/A" : case1Answer;
                          return (
                            <FlexWrapper>
                              <SubItemIcon>
                                <IconWrapper>
                                  <SubBoxIcon />
                                </IconWrapper>
                              </SubItemIcon>
                              <SubItemText>{question?.fieldName} :</SubItemText>
                              <SubItemText>
                                {isCase1Boolean ? (
                                  renderUpdatedFieldInContent(case1PrevDisplay, case1Display, showUpdated)
                                ) : (
                                  <CopyToClipboard text={case1Display || case1PrevDisplay}>
                                    {renderUpdatedFieldInContent(case1PrevDisplay, case1Display, showUpdated)}
                                  </CopyToClipboard>
                                )}
                              </SubItemText>
                            </FlexWrapper>
                          );
                        case 2:
                          const selectedCheckBox: any = question?.options?.find((option: any) => option.name === question?.answers?.answer);
                          return (
                            <>
                              <FlexWrapper>
                                <SubItemIcon>
                                  <IconWrapper>
                                    <SubBoxIcon />
                                  </IconWrapper>
                                </SubItemIcon>
                                <SubItemText>{question?.fieldName} :</SubItemText>
                                <SubItemText>
                                  {renderUpdatedFieldInContent(question?.answers?.previousAnswer === "true" ? "Yes" : question?.answers?.previousAnswer === "false" ? "No" : question?.answers === null ? "No" : question?.answers?.previousAnswer, question?.answers?.answer === "true" ? "Yes" : question?.answers?.answer === "false" ? "No" : question?.answers === null ? "No" : question?.answers?.answer, showUpdated)}
                                </SubItemText>
                              </FlexWrapper>
                              {(sortByDate(selectedCheckBox?.subQuestion, "createdAt"))?.map((subQ: any) => {
                                const subQPrevAnswer = subQ?.answers?.previousAnswer;
                                const subQAnswer = subQ?.answers?.answer;
                                const isSubQBoolean = subQPrevAnswer === "true" || subQPrevAnswer === "false" || subQAnswer === "true" || subQAnswer === "false";
                                return (
                                  <FlexWrapper>
                                    <SubItemIcon>
                                      <IconWrapper>
                                        <SubBoxIcon />
                                      </IconWrapper>
                                    </SubItemIcon>
                                    <SubItemText>{subQ?.fieldName} :</SubItemText>
                                    <SubItemText>
                                      {isSubQBoolean ? (
                                        renderUpdatedFieldInContent(
                                          subQPrevAnswer === "true" ? "Yes" : subQPrevAnswer === "false" ? "No" : subQPrevAnswer,
                                          subQAnswer === "true" ? "Yes" : subQAnswer === "false" ? "No" : subQAnswer,
                                          showUpdated
                                        )
                                      ) : (
                                        <CopyToClipboard text={subQAnswer || subQPrevAnswer}>
                                          {renderUpdatedFieldInContent(subQPrevAnswer, subQAnswer, showUpdated)}
                                        </CopyToClipboard>
                                      )}
                                    </SubItemText>
                                  </FlexWrapper>
                                );
                              })}
                            </>
                          );
                        case 3:
                          const updateOptionsToSearch = question?.dynamicOptions || question?.options || [];
                          const selectedPreviousOption: any = updateOptionsToSearch.find((option: any) => option.id === question?.answers?.previousAnswer || option.name === question?.answers?.previousAnswer);
                          const selectedCurrentOption: any = updateOptionsToSearch.find((option: any) => option.id === question?.answers?.answer || option.name === question?.answers?.answer);
                          const previousDisplayValue = selectedPreviousOption
                            ? (selectedPreviousOption.code ? `${selectedPreviousOption.name} - ${selectedPreviousOption.code}` : selectedPreviousOption.name)
                            : question?.answers?.previousAnswer;
                          const currentDisplayValue = selectedCurrentOption
                            ? (selectedCurrentOption.code ? `${selectedCurrentOption.name} - ${selectedCurrentOption.code}` : selectedCurrentOption.name)
                            : question?.answers?.answer;
                          const selectedOptionBrand: any = selectedCurrentOption;
                          return (
                            <>
                              <FlexWrapper>
                                <SubItemIcon>
                                  <IconWrapper>
                                    <SubBoxIcon />
                                  </IconWrapper>
                                </SubItemIcon>
                                <SubItemText>{question?.fieldName} :</SubItemText>
                                <SubItemText>
                                  {question?.dynamicOptions && question?.dynamicOptions?.length > 0 ? (
                                    selectedOptionBrand ? (
                                      <EstablishmentPopover
                                        establishment={selectedOptionBrand}
                                        onManage={selectedOptionBrand?.id ? () => handleManageEstablishment(selectedOptionBrand.id) : undefined}
                                      >
                                        <span style={{
                                          color: '#1890ff',
                                          fontWeight: 'bold',
                                          cursor: 'pointer'
                                        }}>
                                          <CopyToClipboard text={currentDisplayValue || previousDisplayValue}>
                                            {renderUpdatedFieldInContent(previousDisplayValue, currentDisplayValue, showUpdated)}
                                          </CopyToClipboard>
                                          <ContactsOutlined style={{ marginLeft: 8 }} />
                                        </span>
                                      </EstablishmentPopover>
                                    ) : (
                                      <span>
                                        <CopyToClipboard text={currentDisplayValue || previousDisplayValue}>
                                          {renderUpdatedFieldInContent(previousDisplayValue, currentDisplayValue, showUpdated)}
                                        </CopyToClipboard>
                                        {question?.EstablishmentType?.id && (
                                          <Button
                                            type="link"
                                            size="small"
                                            icon={<PlusOutlined />}
                                            onClick={() => handleAddEstablishment(question.EstablishmentType.id)}
                                            style={{ marginLeft: 8, padding: 0 }}
                                          >
                                            Add Establishment
                                          </Button>
                                        )}
                                      </span>
                                    )
                                  ) : (
                                    <span>
                                      <CopyToClipboard text={currentDisplayValue || previousDisplayValue}>
                                        {renderUpdatedFieldInContent(previousDisplayValue, currentDisplayValue, showUpdated)}
                                      </CopyToClipboard>
                                    </span>
                                  )}
                                </SubItemText>
                              </FlexWrapper>
                              {(sortByDate(selectedOptionBrand?.subQuestion, "createdAt"))?.map((subQ: any) => {
                                const subQAnswer = subQ?.answers?.answer;
                                const isSubQBoolean = subQAnswer === "true" || subQAnswer === "false";
                                return (
                                  <FlexWrapper>
                                    <SubItemIcon>
                                      <IconWrapper>
                                        <SubBoxIcon />
                                      </IconWrapper>
                                    </SubItemIcon>
                                    <SubItemText>{subQ?.fieldName} :</SubItemText>
                                    <SubItemText>
                                      {isSubQBoolean ? (
                                        renderUpdatedFieldInContent(
                                          subQAnswer === "true" ? "Yes" : subQAnswer === "false" ? "No" : subQAnswer,
                                          "",
                                          showUpdated
                                        )
                                      ) : (
                                        <CopyToClipboard text={subQAnswer}>
                                          {renderUpdatedFieldInContent(subQAnswer, "", showUpdated)}
                                        </CopyToClipboard>
                                      )}
                                    </SubItemText>
                                  </FlexWrapper>
                                );
                              })}
                            </>
                          );
                        default:
                          return null;
                      }
                    })}
                  </> : <>
                    {(() => {
                      const locSortedQs = sortByDate(dataToRender?.establishmentType?.questions || [], "createdAt") || [];
                      const isLocBooleanQ = (q: any) => {
                        if (q?.answers === null || !q?.answers?.answer) return false;
                        if (q.answers.answer !== "true" && q.answers.answer !== "false") return false;
                        // Hide unchecked/blank checkboxes (answer "false" means left blank/unchecked)
                        if (q.answers.answer === "false") return false;
                        if (q.fieldType === 2) {
                          const selOpt: any = q?.options?.find((o: any) => o.name === q.answers.answer);
                          if (selOpt?.subQuestion?.length) return false;
                        }
                        return q.fieldType === 1 || q.fieldType === 2;
                      };
                      const locBoolQs = locSortedQs.filter((q: any) => {
                        const pendingA = dataToRender?.pendingRequest?.data?.establishmentType?.questions?.find((uq: any) => uq.fieldName === q?.fieldName)?.answers?.answer;
                        if (q?.answers === null && !pendingA) return false;
                        if (!q?.answers?.answer && q?.answers?.answer !== false && !pendingA) return false;
                        return isLocBooleanQ(q);
                      });
                      const locOtherQs = locSortedQs.filter((q: any) => {
                        if (locBoolQs.includes(q)) return false;
                        // Also hide unchecked boolean checkboxes from the regular list
                        if ((q.fieldType === 1 || q.fieldType === 2) && q?.answers?.answer === "false") return false;
                        return true;
                      });
                      return (
                        <>
                          {locBoolQs.length > 0 && (
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '2px 16px', margin: '6px 0', fontSize: 14, lineHeight: '24px' }}>
                              {locBoolQs.map((q: any) => (
                                <span key={q.id}>
                                  <span style={{ color: '#666' }}>{q.fieldName}:</span>{' '}
                                  {q.answers.answer === "true" ? "Yes" : "No"}
                                </span>
                              ))}
                            </div>
                          )}
                          {locOtherQs.map((question: any) => {
                            const pendingLocAnswer = dataToRender?.pendingRequest?.data?.establishmentType?.questions?.find((q: any) => q.fieldName === question?.fieldName)?.answers?.answer;
                            if (question?.answers === null && !pendingLocAnswer) return null;
                            if (!question?.answers?.answer && question?.answers?.answer !== false && !pendingLocAnswer) return null;
                            switch (question.fieldType) {
                              case 1:
                                const case1AnswerVal = question?.answers?.answer;
                                const case1DisplayVal = case1AnswerVal === "true" ? "Yes" : case1AnswerVal === "false" ? "No" : case1AnswerVal;
                                const pendingCase1Answer = dataToRender?.pendingRequest?.data?.subCategory?.questions?.find((q: any) => q.fieldName === question?.fieldName)?.answers?.answer;
                                return (
                                  <FlexWrapper key={question.id}>
                                    <SubItemIcon>
                                      <IconWrapper>
                                        <SubBoxIcon />
                                      </IconWrapper>
                                    </SubItemIcon>
                                    <SubItemText>{question?.fieldName} :</SubItemText>
                                    <SubItemText>
                                      <CopyToClipboard text={pendingCase1Answer || case1DisplayVal}>
                                        {renderUpdatedFieldInContent(case1DisplayVal, pendingCase1Answer, showUpdated)}
                                      </CopyToClipboard>
                                    </SubItemText>
                                  </FlexWrapper>
                                );
                              case 2:
                                const selectedCheckBox: any = question?.options?.find((option: any) => option.name === question?.answers?.answer);
                                return (
                                  <>
                                    <FlexWrapper>
                                      <SubItemIcon>
                                        <IconWrapper>
                                          <SubBoxIcon />
                                        </IconWrapper>
                                      </SubItemIcon>
                                      <SubItemText>{question?.fieldName} :</SubItemText>
                                      <SubItemText>
                                        {renderUpdatedFieldInContent(question?.answers?.answer === "true" ? "Yes" : question?.answers?.answer === "false" ? "No" : question?.answers?.answer, dataToRender?.pendingRequest?.data?.subCategory?.questions?.find((q: any) => q.fieldName === question?.fieldName)?.answers?.answer, showUpdated)}
                                      </SubItemText>
                                    </FlexWrapper>
                                    {(sortByDate(selectedCheckBox?.subQuestion, "createdAt"))?.map((subQ: any) => {
                                      const subQAnswer = subQ?.answers?.answer;
                                      const isSubQBoolean = subQAnswer === "true" || subQAnswer === "false";
                                      return (
                                        <FlexWrapper key={subQ.id}>
                                          <SubItemIcon>
                                            <IconWrapper>
                                              <SubBoxIcon />
                                            </IconWrapper>
                                          </SubItemIcon>
                                          <SubItemText>{subQ?.fieldName} :</SubItemText>
                                          <SubItemText>
                                            {isSubQBoolean ? (
                                              renderUpdatedFieldInContent(
                                                subQAnswer === "true" ? "Yes" : subQAnswer === "false" ? "No" : subQAnswer,
                                                "",
                                                showUpdated
                                              )
                                            ) : (
                                              <CopyToClipboard text={subQAnswer}>
                                                {renderUpdatedFieldInContent(subQAnswer, "", showUpdated)}
                                              </CopyToClipboard>
                                            )}
                                          </SubItemText>
                                        </FlexWrapper>
                                      );
                                    })}
                                  </>
                                );
                              case 3:
                          // Check dynamicOptions first (for questions with questionType), then fall back to static options
                          const optionsToSearch = question?.dynamicOptions || question?.options || [];
                          const selectedOptionBrand: any = optionsToSearch.find((option: any) => option.id === question?.answers?.answer || option.name === question?.answers?.answer);
                          const displayValue = selectedOptionBrand
                            ? (selectedOptionBrand.code ? `${selectedOptionBrand.name} - ${selectedOptionBrand.code}` : selectedOptionBrand.name)
                            : question?.answers?.answer;
                          return (
                            <>
                              <FlexWrapper>
                                <SubItemIcon>
                                  <IconWrapper>
                                    <SubBoxIcon />
                                  </IconWrapper>
                                </SubItemIcon>
                                <SubItemText>{question?.fieldName} :</SubItemText>
                                <SubItemText>
                                  {question?.dynamicOptions && question?.dynamicOptions?.length > 0 ? (
                                    selectedOptionBrand ? (
                                      <EstablishmentPopover
                                        establishment={selectedOptionBrand}
                                        onManage={selectedOptionBrand?.id ? () => handleManageEstablishment(selectedOptionBrand.id) : undefined}
                                      >
                                        <span style={{
                                          color: '#1890ff',
                                          fontWeight: 'bold',
                                          cursor: 'pointer'
                                        }}>
                                          <CopyToClipboard text={displayValue}>
                                            {renderUpdatedFieldInContent(
                                              displayValue,
                                              dataToRender?.pendingRequest?.data?.subCategory?.questions?.find((q) => q.fieldName === question?.fieldName)?.answers?.answer,
                                              showUpdated
                                            )}
                                          </CopyToClipboard>
                                          <ContactsOutlined style={{ marginLeft: 8 }} />
                                        </span>
                                      </EstablishmentPopover>
                                    ) : (
                                      <span>
                                        <CopyToClipboard text={displayValue}>
                                          {renderUpdatedFieldInContent(
                                            displayValue,
                                            dataToRender?.pendingRequest?.data?.subCategory?.questions?.find((q) => q.fieldName === question?.fieldName)?.answers?.answer,
                                            showUpdated
                                          )}
                                        </CopyToClipboard>
                                        {question?.EstablishmentType?.id && (
                                          <Button
                                            type="link"
                                            size="small"
                                            icon={<PlusOutlined />}
                                            onClick={() => handleAddEstablishment(question.EstablishmentType.id)}
                                            style={{ marginLeft: 8, padding: 0 }}
                                          >
                                            Add Establishment
                                          </Button>
                                        )}
                                      </span>
                                    )
                                  ) : (
                                    <span>
                                      <CopyToClipboard text={displayValue}>
                                        {renderUpdatedFieldInContent(
                                          displayValue,
                                          dataToRender?.pendingRequest?.data?.subCategory?.questions?.find((q) => q.fieldName === question?.fieldName)?.answers?.answer,
                                          showUpdated
                                        )}
                                      </CopyToClipboard>
                                    </span>
                                  )}
                                </SubItemText>
                              </FlexWrapper>
                              {(sortByDate(selectedOptionBrand?.subQuestion, "createdAt"))?.map((subQ: any) => {
                                const subQAnswer = subQ?.answers?.answer;
                                const isSubQBoolean = subQAnswer === "true" || subQAnswer === "false";
                                return (
                                  <FlexWrapper>
                                    <SubItemIcon>
                                      <IconWrapper>
                                        <SubBoxIcon />
                                      </IconWrapper>
                                    </SubItemIcon>
                                    <SubItemText>{subQ?.fieldName} :</SubItemText>
                                    <SubItemText>
                                      {isSubQBoolean ? (
                                        renderUpdatedFieldInContent(
                                          subQAnswer === "true" ? "Yes" : subQAnswer === "false" ? "No" : subQAnswer,
                                          "",
                                          showUpdated
                                        )
                                      ) : (
                                        <CopyToClipboard text={subQAnswer}>
                                          {renderUpdatedFieldInContent(subQAnswer, "", showUpdated)}
                                        </CopyToClipboard>
                                      )}
                                    </SubItemText>
                                  </FlexWrapper>
                                );
                              })}
                            </>
                          );
                              default:
                                return null;
                            }
                          })}
                        </>
                      );
                    })()}
                  </>}

                  {/* Booking Number */}
                  {(dataToRender?.bookingNumber?.trim() || dataToRender?.pendingRequest?.data?.bookingNumber) && (
                    <FlexWrapper>
                      <SubItemIcon>
                        <BookOutlined />
                      </SubItemIcon>
                      <SubItemText>Booking / Reservation Number :</SubItemText>
                      <SubItemText>
                        <CopyToClipboard text={dataToRender?.pendingRequest?.data?.bookingNumber || dataToRender?.bookingNumber}>
                          {renderUpdatedFieldInContent(dataToRender?.bookingNumber, dataToRender?.pendingRequest?.data?.bookingNumber, showUpdated)}
                        </CopyToClipboard>
                      </SubItemText>
                    </FlexWrapper>
                  )}
                  {/* Additional Information */}
                  {/* <FlexWrapper>
                    <SubItemIcon>
                      <InfoCircleOutlined />
                    </SubItemIcon>
                    <SubItemText>Additional Information :</SubItemText>
                    <SubItemText>{renderUpdatedFieldInContent(dataToRender?.whereDescription || " N/A", dataToRender?.pendingRequest?.data?.whereDescription, showUpdated)}</SubItemText>
                  </FlexWrapper> */}
                </>
              )}
            </CardWrapper>
          </StyledCol>
        </Row>

        {/* Row 2: User Behaviour + L&F Notified Contact Information */}
        {(dataToRender?.visitorInfo || dataToRender?.status === LostStatuses.LFNotified || (dataToRender?.status === LostStatuses.Deleted && (dataToRender?.lfNotifications?.length || dataToRender?.lfDepartmentName))) && (
          <Row gutter={12} style={{ marginTop: 12 }}>
            {dataToRender?.visitorInfo && (
              <Col xs={24} lg={12}>
                <CardWrapper title="User Behaviour">
                  <div style={{ display: 'flex', gap: 24, marginBottom: 4, flexWrap: 'wrap' }}>
                    <SubItemText style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 13, color: '#999', lineHeight: '24px' }}>Entry URL</div>
                      <Tooltip title={dataToRender.visitorInfo.entryUrl} placement="topLeft">
                        <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: 14, lineHeight: '24px' }}>
                          <CopyToClipboard text={dataToRender.visitorInfo.entryUrl}>
                            {(() => { try { const u = new URL(dataToRender.visitorInfo.entryUrl); return u.pathname + u.search + u.hash; } catch { return dataToRender.visitorInfo.entryUrl; } })()}
                          </CopyToClipboard>
                        </div>
                      </Tooltip>
                    </SubItemText>
                    {dataToRender.visitorInfo.exitUrl && (
                      <SubItemText style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: 13, color: '#999', lineHeight: '24px' }}>Exit URL</div>
                        <Tooltip title={dataToRender.visitorInfo.exitUrl} placement="topLeft">
                          <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: 14, lineHeight: '24px' }}>
                            {(() => { try { const u = new URL(dataToRender.visitorInfo.exitUrl); return u.pathname + u.search + u.hash; } catch { return dataToRender.visitorInfo.exitUrl; } })()}
                          </div>
                        </Tooltip>
                      </SubItemText>
                    )}
                    <SubItemText style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 13, color: '#999', lineHeight: '24px' }}>Referrer</div>
                      <Tooltip title={dataToRender.visitorInfo.referrer || 'Direct'} placement="topLeft">
                        <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: 14, lineHeight: '24px' }}>
                          {dataToRender.visitorInfo.referrer || 'Direct'}
                        </div>
                      </Tooltip>
                    </SubItemText>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px 12px' }}>
                    <SubItemText>
                      <div style={{ fontSize: 13, color: '#999', lineHeight: '24px' }}>Browser</div>
                      <div style={{ fontSize: 14, lineHeight: '24px' }}>{dataToRender.visitorInfo.browser || '-'}</div>
                    </SubItemText>
                    <SubItemText>
                      <div style={{ fontSize: 13, color: '#999', lineHeight: '24px' }}>Device / OS</div>
                      <div style={{ fontSize: 14, lineHeight: '24px' }}>{[dataToRender.visitorInfo.device, dataToRender.visitorInfo.os].filter(Boolean).join(' · ') || '-'}</div>
                    </SubItemText>
                    {dataToRender.visitorInfo.ip && (
                      <SubItemText>
                        <div style={{ fontSize: 13, color: '#999', lineHeight: '24px' }}>IP Address</div>
                        <div style={{ fontSize: 14, lineHeight: '24px' }}>
                          <CopyToClipboard text={dataToRender.visitorInfo.ip}>
                            {dataToRender.visitorInfo.ip}
                          </CopyToClipboard>
                        </div>
                      </SubItemText>
                    )}
                    {(dataToRender.visitorInfo.city || dataToRender.visitorInfo.country) && (
                      <SubItemText>
                        <div style={{ fontSize: 13, color: '#999', lineHeight: '24px' }}>Location</div>
                        <div style={{ fontSize: 14, lineHeight: '24px' }}>{[dataToRender.visitorInfo.city, dataToRender.visitorInfo.region, dataToRender.visitorInfo.country].filter(Boolean).join(', ') || '-'}</div>
                      </SubItemText>
                    )}
                    <SubItemText>
                      <div style={{ fontSize: 13, color: '#999', lineHeight: '24px' }}>Session Started</div>
                      <div style={{ fontSize: 14, lineHeight: '24px' }}>
                        {dataToRender.visitorInfo.sessionStartedAt
                          ? new Date(dataToRender.visitorInfo.sessionStartedAt).toLocaleString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
                          : '-'}
                      </div>
                    </SubItemText>
                    {dataToRender.visitorInfo.pagesVisited > 0 && (
                      <SubItemText>
                        <div style={{ fontSize: 13, color: '#999', lineHeight: '24px' }}>Pages Visited</div>
                        <div style={{ fontSize: 14, lineHeight: '24px' }}>{dataToRender.visitorInfo.pagesVisited}</div>
                      </SubItemText>
                    )}
                  </div>
                </CardWrapper>
              </Col>
            )}

            {/* L&F Notified Contact Information — compact one-line entries with tooltip */}
            {(dataToRender?.status === LostStatuses.Review || dataToRender?.status === LostStatuses.LFNotified || (dataToRender?.status === LostStatuses.Deleted && (dataToRender?.lfNotifications?.length || dataToRender?.lfDepartmentName))) && (
              <Col xs={24} lg={dataToRender?.visitorInfo ? 12 : 24}>
                <CardWrapper title="L&F Contacts">
                  {dataToRender?.lfNotifications?.length ? (
                    dataToRender.lfNotifications.map((notification: any, idx: number) => {
                      const line = [notification.establishmentName, notification.lfContactPerson, notification.lfContactEmail].filter(Boolean).join(' · ');
                      const tooltipContent = (
                        <div>
                          {notification.establishmentName && <div><strong>Establishment:</strong> {notification.establishmentName}</div>}
                          {notification.lfDepartmentName && <div><strong>Department:</strong> {notification.lfDepartmentName}</div>}
                          {notification.lfContactPerson && <div><strong>Contact:</strong> {notification.lfContactPerson}</div>}
                          {notification.lfContactEmail && <div><strong>Email:</strong> {notification.lfContactEmail}</div>}
                          {notification.lfContactPhone && <div><strong>Phone:</strong> {notification.lfContactPhone}</div>}
                          {notification.additionalComments && <div style={{ marginTop: 4 }}><strong>Comments:</strong> {notification.additionalComments}</div>}
                        </div>
                      );
                      return (
                        <div key={idx} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, borderBottom: idx < dataToRender.lfNotifications!.length - 1 ? '1px solid #f0f0f0' : 'none', padding: '6px 0' }}>
                          <Tooltip title={tooltipContent} placement="topLeft" overlayStyle={{ maxWidth: 360 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', flex: 1, minWidth: 0 }}>
                              <ContactsOutlined style={{ color: '#1890ff', fontSize: 14, flexShrink: 0 }} />
                              <span style={{ fontSize: 14, lineHeight: '24px', color: '#374151', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {line || notAvailable}
                              </span>
                            </div>
                          </Tooltip>
                          <Input
                            size="middle"
                            placeholder="Comment..."
                            defaultValue={notification.additionalComments || ''}
                            suffix={savingFields[`${idx}-additionalComments`] ? <LoadingOutlined style={{ color: '#1890ff', fontSize: 12 }} /> : savedFields[`${idx}-additionalComments`] ? <CheckOutlined style={{ color: '#52c41a', fontSize: 12 }} /> : <span />}
                            style={{ width: 150, fontSize: 13, flexShrink: 0 }}
                            onBlur={(e) => {
                              const val = e.target.value.trim();
                              if (val !== (notification.additionalComments || '')) {
                                handleLFCommentSave(idx, val, 'additionalComments');
                              }
                            }}
                            onPressEnter={(e) => {
                              (e.target as HTMLInputElement).blur();
                            }}
                          />
                          <Input
                            size="middle"
                            placeholder="Note..."
                            defaultValue={notification.adminComment || ''}
                            suffix={savingFields[`${idx}-adminComment`] ? <LoadingOutlined style={{ color: '#1890ff', fontSize: 12 }} /> : savedFields[`${idx}-adminComment`] ? <CheckOutlined style={{ color: '#52c41a', fontSize: 12 }} /> : <span />}
                            style={{ width: 150, fontSize: 13, flexShrink: 0 }}
                            onBlur={(e) => {
                              const val = e.target.value.trim();
                              if (val !== (notification.adminComment || '')) {
                                handleLFCommentSave(idx, val);
                              }
                            }}
                            onPressEnter={(e) => {
                              (e.target as HTMLInputElement).blur();
                            }}
                          />
                        </div>
                      );
                    })
                  ) : dataToRender?.lfDepartmentName ? (
                    /* Fallback: legacy single-entry */
                    (() => {
                      const line = [dataToRender?.establishmentName, dataToRender?.lfContactPerson, dataToRender?.lfContactEmail].filter(Boolean).join(' · ');
                      const tooltipContent = (
                        <div>
                          {dataToRender?.establishmentName && <div><strong>Establishment:</strong> {dataToRender.establishmentName}</div>}
                          {dataToRender?.lfDepartmentName && <div><strong>Department:</strong> {dataToRender.lfDepartmentName}</div>}
                          {dataToRender?.lfContactPerson && <div><strong>Contact:</strong> {dataToRender.lfContactPerson}</div>}
                          {dataToRender?.lfContactEmail && <div><strong>Email:</strong> {dataToRender.lfContactEmail}</div>}
                          {dataToRender?.lfContactPhone && <div><strong>Phone:</strong> {dataToRender.lfContactPhone}</div>}
                          {dataToRender?.additionalComments && <div style={{ marginTop: 4 }}><strong>Comments:</strong> {dataToRender.additionalComments}</div>}
                        </div>
                      );
                      return (
                        <Tooltip title={tooltipContent} placement="topLeft" overlayStyle={{ maxWidth: 360 }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 0', cursor: 'pointer' }}>
                            <ContactsOutlined style={{ color: '#1890ff', fontSize: 14, flexShrink: 0 }} />
                            <span style={{ fontSize: 14, lineHeight: '24px', color: '#374151', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                              {line || notAvailable}
                            </span>
                          </div>
                        </Tooltip>
                      );
                    })()
                  ) : (
                    <div style={{ color: '#999', textAlign: 'center', padding: '12px 0', fontSize: 13 }}>
                      No L&F contacts added yet.
                    </div>
                  )}
                  {(dataToRender?.status === LostStatuses.Review || dataToRender?.status === LostStatuses.LFNotified) && (
                    <AddButtonWarper style={{ marginTop: 8 }}>
                      <Button type="primary" icon={<PlusOutlined />} onClick={() => setShowBodyLFModal(true)} style={{ padding: '18px', borderRadius: 3, boxShadow: 'none' }}>
                        View/ Add L&F Contact
                      </Button>
                    </AddButtonWarper>
                  )}
                </CardWrapper>
              </Col>
            )}
          </Row>
        )}

        {showPreMatchFoundItem && <PreMatchFoundItem />}

        {/* Only show Activity section in Latest tab */}

        <ReportDetailsWrapper>
          <StyledTitle level={4}>Activity</StyledTitle>
          {isLoading ? (
            <Skeleton paragraph={{ rows: 6 }} active />
          ) : (
            <>
              <ActivityWrapper>
                <Flex align="center" justify="space-between" style={{ flexWrap: "wrap", }} >
                  <Flex gap={18}>
                      <ActivityIconWrapper backgroundColor="#FFF0F6" >
                        <FireFilled style={{ color: "#FF85C0" }} /> <Switch checked={dataToRender?.isUrgent} onChange={handleIsUrgentChange} />
                      </ActivityIconWrapper>
                      <ActivityIconWrapper backgroundColor="#E6F4FF" >
                        <EmailUnreadIcon /> <Switch checked={isEmailCommunication} onChange={onChange} />
                      </ActivityIconWrapper>
                      <Tooltip placement="top" title={`Escalate ${openStickys?.length}/3`}>
                        <StyledStickyButtonWrapper disabled={openStickys?.length === 3 || stickyDataSorted?.length === 10} onClick={() => {
                          setIsMarkModalOpen(true);
                          setStickyModalType("add");
                        }}>
                          <StyledStickyButtonText>Escalate [{openStickys?.length}/3]</StyledStickyButtonText>
                          <StickyNoteIcon />
                        </StyledStickyButtonWrapper>
                      </Tooltip>
                  </Flex>
                  <Flex gap={12}>
                    {isPaymentSucceeded && dataToRender?.lfNotifiedAt && (
                      <Tooltip placement="top" title="Generate & download Proof of Service Completion">
                        <ButtonWarper variant="outlined" icon={<ServiceCompletionIcon />} iconPosition={"end"} color="default" loading={serviceCompletionLoading} onClick={() => report?.id && handleServiceCompletion(report.id)}>
                          <StyledLabel>Service Completion</StyledLabel>
                        </ButtonWarper>
                      </Tooltip>
                    )}

                    {(dataToRender?.digitalSignature || dataToRender?.idDocumentUrl) && (
                      <Tooltip placement="top" title="View Signature & ID Verification">
                        <ButtonWarper variant="outlined" icon={<UserRound />} iconPosition={"end"} color="default" onClick={() => setIsSignatureVerificationModal(true)}>
                          <StyledLabel>Signature & ID</StyledLabel>
                        </ButtonWarper>
                      </Tooltip>
                    )}

                    {dataToRender?.id && dataToRender?.donatedDoc?.fullUrl && (
                      <Tooltip placement="top" title="Donated Document">
                        <ButtonWarper variant="outlined" icon={<DownloadDonateIcon />} iconPosition={"end"} color="default" onClick={() => report?.id && report?.donatedDoc && handleDownloadDocument(report?.id, report?.donatedDoc, `Donated_${report?.id}.pdf`)}>
                          <StyledLabel>Donated</StyledLabel>
                        </ButtonWarper>
                      </Tooltip>
                    )}

                    {/* {isPaymentSucceeded && !isDeleteStatus && <Tooltip placement="top" title={report?.shippingLabel?.id ? "Download Shipping Label/ Additional Docs/ Edit Courier Tracking Info" : "Upload Shipping Label/ Additional Docs/ Add Courier Tracking Info"}>
                      <ButtonWarper variant="outlined" icon={<BarcodeIcon />} iconPosition={"end"} color="default" onClick={() => setIsShippingModal(true)}>
                        <StyledLabel>Shipping Label/ Docs/ Tracking</StyledLabel>
                      </ButtonWarper>
                    </Tooltip>} */}

                    {isPaymentSucceeded && isAccessPaymentLogs && <Tooltip placement="top" title="Download payment receipt">
                      <ButtonWarper variant="outlined" icon={<PaymentTermsIcon />} iconPosition={"end"} color="default" onClick={() => report?.id && paymentSucceededReceipt?.id && handleDownloadDocument(report?.id, paymentSucceededReceipt, `Receipt_${report?.id}.pdf`)}>
                        <StyledLabel>Receipt</StyledLabel>
                      </ButtonWarper>
                    </Tooltip>}

                    {latestUpdatedReportDocument?.fullUrl && (
                      <Tooltip placement="top" title="Download lost report">
                        <ButtonWarper variant="outlined" icon={<ReceiptIcon />} iconPosition={"end"} color="default" onClick={() => report?.id && handleDownloadDocument(report?.id, latestUpdatedReportDocument, `Report_${report?.id}.pdf`)}>
                          <StyledLabel>Report</StyledLabel>
                        </ButtonWarper>
                      </Tooltip>
                    )}
                  </Flex>
                </Flex>
              </ActivityWrapper>

              <Divider style={{ margin: "30px 0" }} />

              <TableContainer>
                <>
                  {stickyStatus === RequestResults.pending ? (
                    <Skeleton paragraph={{ rows: 6 }} active />
                  ) : stickyDataSorted?.map((item) => {
                    const isChecked = checkedItems[item.id] || false;
                    return (
                      <StyledFlex status={item?.status}>
                        <StickyWrapper key={item.id}>
                          <TextSubWrapper>
                            {item?.status === 1 ? <SVGIconWrapper><StickyNoteIcon /></SVGIconWrapper> : <SVGIconWrapper><StickyIcon /></SVGIconWrapper>} {item?.content} <span>{item?.updatedAt && convertUtcToLocal(item?.updatedAt, "MM/DD/YYYY")} @ {item?.updatedAt && convertUtcToLocal(item?.updatedAt, "HH:mm:ss")}</span>
                          </TextSubWrapper>
                          {item?.status === 1 ? <Flex align="center" gap={16}>
                            <EditIcon onClick={() => handleStickyModalOpen("update", item)} />
                            {isMarkStickyAsDonePermission && <Checkbox className="report-details-checkbox" checked={isChecked} onChange={(e) => handleCheckboxChange(e, item)}>Mark as done</Checkbox>}
                          </Flex> : <Flex align="center" gap={8}>
                            <CheckCircleIcon />
                            <div>Done</div>
                          </Flex>}
                        </StickyWrapper>
                      </StyledFlex>
                    );
                  })}
                </>

                <ReportActivityLogs handleEditNoteModalOpen={handleEditNoteModalOpen} report={report as any} />

              </TableContainer>
              <AddComment lostId={dataToRender?.id?.toString()} />
            </>
          )}
        </ReportDetailsWrapper>
        {/* <PrematchModal
          form={form}
          isMarkModalOpen={isPrematchModalOpen}
          handleFormSubmit={handleFormSubmit}
          handleMarkCancel={handlePrematchModalCancel}
          handleMarkChange={() => { }}
          selectedItem={selectedItem}
        /> */}

        {/* <ReportModal form={form} isModalOpen={isReportModalOpen} handleOk={handleOk} handleCancel={()=>setIsReportModalOpen(false)} /> */}

        {isMarkAsDoneOpen && (
          <ConfirmationModal
            handleSave={handleSave}
            isModalOpen={!!isMarkAsDoneOpen}
            onCancel={onCancel}
            title={`Mark as done`}
            message={`Are you sure you want to mark as done?`}
            confirmButtonText="Done"
            loading={isMarkAsDoneLoading}
          />
        )}

        {isMarkModalOpen && (
          <AddUpdateStickyModal
            title={stickyModalType === "update" ? "Update Escalate" : "Escalate"}
            confirmLabel={stickyModalType === "update" ? "Update Escalate" : "Escalate"}
            handleFormSubmit={handleFormSubmit}
            isMarkModalOpen={isMarkModalOpen}
            handleMarkCancel={handleMarkCancel}
            form={form}
            loading={addUpdateStickyLoading}
          />
        )}

        {isEditNoteModalOpen && (
          <AddUpdateCommentModal
            title="Update Comment"
            confirmLabel="Update Comment"
            handleFormSubmit={handleUpdateCommentSubmit}
            isMarkModalOpen={isEditNoteModalOpen}
            handleMarkCancel={handleCommentCancel}
            form={commentForm}
            loading={addUpdateCommentLoading}
          />
        )}

        {/* L&F Contacts Modal - opened from body */}
        {showBodyLFModal && (
          <LFNotifiedModal
            isOpen={showBodyLFModal}
            onClose={() => setShowBodyLFModal(false)}
            onSave={handleBodyLFSave}
            loading={bodyLFLoading}
            report={report}
            confirmButtonText="Save Contacts"
            existingNotifications={dataToRender?.lfNotifications || []}
            skipAutoPopulate={!!(dataToRender?.lfNotifications?.length)}
          />
        )}

        {/* Email Selection Confirmation */}
        {showEmailConfirmModal && (() => {
          // Build full list: existing + new, then group by location
          const allEntries = [...(dataToRender?.lfNotifications || []), ...pendingLFDetails];
          const locationGroups: { locationName: string; contacts: { idx: number; name: string; email: string }[] }[] = [];
          const locationMap = new Map<string, number>();

          allEntries.forEach((entry: any, idx: number) => {
            const locKey = entry.establishmentLocationId || entry.establishmentName || `loc-${idx}`;
            const locName = entry.establishmentName || 'Unknown Location';
            const code = entry.establishmentCode || '';
            const locLabel = code ? `${locName} (${code})` : locName;
            const contactName = entry.lfDepartmentName || entry.lfContactPerson || `Contact ${idx + 1}`;

            if (!locationMap.has(locKey)) {
              locationMap.set(locKey, locationGroups.length);
              locationGroups.push({ locationName: locLabel, contacts: [] });
            }
            locationGroups[locationMap.get(locKey)!].contacts.push({
              idx,
              name: contactName,
              email: entry.lfContactEmail || '',
            });
          });

          const totalContacts = allEntries.length;
          const allChecked = emailCheckedIndices.length === totalContacts;
          const someChecked = emailCheckedIndices.length > 0 && !allChecked;

          return (
            <StyledModal
              title="Send Email Notification"
              open={showEmailConfirmModal}
              onCancel={() => {
                setShowEmailConfirmModal(false);
                setPendingLFDetails([]);
                setEmailCheckedIndices([]);
              }}
              footer={
                <>
                  <Button onClick={() => handleEmailConfirm(false)} disabled={bodyLFLoading}>
                    Save without email
                  </Button>
                  <Button
                    type="primary"
                    onClick={() => handleEmailConfirm(true)}
                    loading={bodyLFLoading}
                    disabled={emailCheckedIndices.length === 0}
                  >
                    Send email ({emailCheckedIndices.length})
                  </Button>
                </>
              }
            >
              <p style={{ marginBottom: 12, color: '#6b7280' }}>
                Select which contacts to include in the email notification to the customer.
              </p>
              <Checkbox
                checked={allChecked}
                indeterminate={someChecked}
                onChange={(e) => setEmailCheckedIndices(e.target.checked ? allEntries.map((_, i) => i) : [])}
                style={{ marginBottom: 10, fontWeight: 600 }}
              >
                Select All
              </Checkbox>
              <div style={{ maxHeight: 350, overflowY: 'auto' }}>
                {locationGroups.map((group, gIdx) => (
                  <div key={gIdx} style={{ marginBottom: 12 }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: '#1f2937', marginBottom: 4 }}>
                      {group.locationName}
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 4, paddingLeft: 16 }}>
                      {group.contacts.map((contact) => (
                        <Checkbox
                          key={contact.idx}
                          checked={emailCheckedIndices.includes(contact.idx)}
                          onChange={(e) => {
                            setEmailCheckedIndices(prev =>
                              e.target.checked ? [...prev, contact.idx] : prev.filter(i => i !== contact.idx)
                            );
                          }}
                        >
                          <span style={{ fontSize: 13 }}>{contact.name}</span>
                          {contact.email && (
                            <span style={{ fontSize: 12, color: '#6b7280', marginLeft: 6 }}>{contact.email}</span>
                          )}
                        </Checkbox>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </StyledModal>
          );
        })()}

        <MarkAsUrgentModal isModalOpen={isModalOpenMarkAsUrgent} handleCancel={() => setIsModalOpenMarkAsUrgent(false)} />
      </DisabledContent>
    );
  };

  const renderVersionTabs = () => {
    const tabItems = [];
    const hasLatestTab = (dataToRender?.versionCount ?? 0) > 1;

    if (reportPendingRequest?.id) {
      const nextVersionNumber = dataToRender?.versionCount && dataToRender?.versionCount > 1 ? (dataToRender?.versionCount ?? 0) - 1 : dataToRender?.versionCount;
      tabItems.push({
        key: "pending",
        label: (
          <Flex justify="space-between" align="center" style={{ width: "100%" }}>
            <span
              style={{
                color: isDeleteRequest ? "#ff4d4f" : "#F5A623",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <ClockCircleOutlined />
              {isDeleteRequest ? "Deleted (Pending)" : `Update ${nextVersionNumber} (Pending)`}
            </span>
          </Flex>
        ),
        children: renderContent(true, "pending"),
      });
    }

    if ((dataToRender?.versionCount ?? 0) > 1) {
      tabItems.push({
        key: "latest",
        label: (
          <Flex justify="space-between" align="center" style={{ width: "100%" }}>
            <span>Latest</span>
          </Flex>
        ),
        children: renderContent(true, "latest"),
      });

      if (dataToRender?.versionCount && dataToRender?.versionCount > 1) {
        for (let i = dataToRender?.versionCount - 2; i > 0; i--) {
          tabItems.push({
            key: `version-${i}`,
            label: `Version ${i}`,
            children: renderContent(true, "version"),
          });
        }
      }
    }

    tabItems.push({
      key: "original",
      label: (
        <Flex justify="space-between" align="center" style={{ width: "100%" }}>
          <span>Original</span>
        </Flex>
      ),
      children: renderContent(false, "original"),
    });

    if (!dataToRender?.versionCount && !reportPendingRequest?.id) {
      return (
        <>
          {isPaymentSucceeded && succeededPayment && (
            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 8, marginBottom: 8 }}>
              {succeededPayment.createdAt && (
                <span style={{ fontSize: 12, color: '#6b7280' }}>
                  Paid: {convertUtcToLocal(succeededPayment.createdAt, "MM/DD/YY hh:mm A")}
                </span>
              )}
              {refundWindowRemaining && (
                <Tooltip
                  title={
                    <div style={{ fontSize: 12, lineHeight: 1.5 }}>
                      <div style={{ fontWeight: 600, marginBottom: 2 }}>⚠ Refund still possible</div>
                      <div>The customer can request a refund for the next <strong>{refundWindowRemaining}</strong>.</div>
                      <div style={{ marginTop: 4, color: "#bfbfbf" }}>Hold off on progressing this claim until the 24-hour window closes.</div>
                    </div>
                  }
                >
                  <span style={{ fontSize: 12, color: '#ff4d4f', fontWeight: 600, cursor: 'help' }}>
                    ⚠ Refund eligible · {refundWindowRemaining} left
                  </span>
                </Tooltip>
              )}
              <span style={{ fontSize: 13, color: '#52c41a', fontWeight: 500 }}>
                ${succeededPayment.totalPayableAmount?.toFixed(2)}
              </span>
              {showEditButtons("original") && Number(report?.status) <= LostStatuses.InProcess && <EditIcon onClick={() => setIsEditReportModalOpen(true)} />}
            </div>
          )}
          {renderContent(false, "original")}
          {isEditReportModalOpen && report && <EditReportDetailsModal isModalOpen={isEditReportModalOpen} report={report} handleOk={() => setIsEditReportModalOpen(false)} handleCancel={() => setIsEditReportModalOpen(false)} />}
        </>
      );
    }

    return (
      <>
        <StyledTabs
          type="card"
          defaultActiveKey={reportPendingRequest?.id ? "pending" : hasLatestTab ? "latest" : "original"}
          onChange={handleTabChange}
          items={tabItems}
          tabBarExtraContent={{
            right: (
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                {isPaymentSucceeded && succeededPayment && (
                  <>
                    {succeededPayment.createdAt && (
                      <span style={{ fontSize: 12, color: '#6b7280' }}>
                        Paid: {convertUtcToLocal(succeededPayment.createdAt, "MM/DD/YY hh:mm A")}
                      </span>
                    )}
                    {refundWindowRemaining && (
                      <span style={{ fontSize: 12, color: '#ff4d4f', fontWeight: 600 }}>
                        ⏱ {refundWindowRemaining}
                      </span>
                    )}
                    <span style={{ fontSize: 13, color: '#52c41a', fontWeight: 500 }}>
                      ${succeededPayment.totalPayableAmount?.toFixed(2)}
                    </span>
                  </>
                )}
                {showEditButtons(tabType) && Number(report?.status) <= LostStatuses.InProcess && <EditIcon onClick={() => setIsEditReportModalOpen(true)} />}
              </div>
            ),
          }}
        />
        {isEditReportModalOpen && report && <EditReportDetailsModal isModalOpen={isEditReportModalOpen} report={report} handleOk={() => setIsEditReportModalOpen(false)} handleCancel={() => setIsEditReportModalOpen(false)} />}
      </>
    );
  };



  return (
    <div style={{ backgroundColor: "#ffffff" }}>
      {reportPendingRequest?.id && (isApproveDisApproveCustomerEditRequest || isApproveDisApproveCustomerDeleteRequest || isApproveDisApproveBillingInfoEditRequest) && (
        <Notification status={isDeleteRequest ? PendingRequestOperation.Delete : PendingRequestOperation.Update} message={pendingRequestMessage} onApprove={handleApproveRequest} onDisapprove={handleDisApproveRequest} form={unlinkForm} title={deleteWithUnlinkRequestTitle} />
      )}

      {/* Refund banner — two variants:
          1. Refund-requested: customer already triggered a refund. Strongest warning, stops
             admins from progressing a claim whose money has been returned.
          2. Refund-window: payment is recent but no refund yet — admin should hold off until
             the 24h refund window closes. */}
      {isRefundRequested ? (
        <Alert
          type="error"
          showIcon
          style={{ marginBottom: 16, borderRadius: 8 }}
          message={<span style={{ fontWeight: 600 }}>Customer requested a refund — do not process this claim</span>}
          description={
            <span style={{ fontSize: 13 }}>
              The customer requested a refund {timeFromReportToRefund && (<><strong style={{ color: "#ff4d4f" }}>{timeFromReportToRefund}</strong> after filing this claim</>)}.
              The payment has been returned, so do not progress this claim (status changes, LF notifications, communications).
              Any work done now is wasted effort.
            </span>
          }
        />
      ) : refundWindowRemaining && (
        <Alert
          type="error"
          showIcon
          style={{ marginBottom: 16, borderRadius: 8 }}
          message={<span style={{ fontWeight: 600 }}>Do not work on this claim yet — customer can still refund</span>}
          description={
            <span style={{ fontSize: 13 }}>
              This claim was paid recently. The customer is eligible to request a refund for
              the next <strong style={{ color: "#ff4d4f" }}>{refundWindowRemaining}</strong>.
              Please hold off on processing (status changes, LF notifications, communications)
              until the 24-hour refund window closes — any work you do now may need to be
              undone if a refund is requested.
            </span>
          }
        />
      )}

      {renderVersionTabs()}

      {isShippingModal && <ShippingModal isMarkModalOpen={isShippingModal} handleMarkCancel={() => setIsShippingModal(false)} handleSaveSuccess={() => { setIsShippingModal(false); report && setShowConfirmItemMove(true); }} />}
      
      {isSignatureVerificationModal && (
        <StyledModal
          title="Signature & ID Verification"
          open={isSignatureVerificationModal}
          onCancel={() => setIsSignatureVerificationModal(false)}
          footer={null}
          width={800}
          centered
          draggable={true}
        >
          <div style={{ padding: '16px 0' }}>
            <Flex gap={16} wrap>
              {dataToRender?.digitalSignature && (
                <div style={{ flex: 1, minWidth: '300px' }}>
                  <h3>Digital Signature</h3>
                  <div style={{ border: '1px solid #d9d9d9', borderRadius: '4px', padding: '8px', marginBottom: '8px' }}>
                    <Image 
                      src={dataToRender.digitalSignature} 
                      alt="Digital Signature"
                      style={{ maxWidth: '100%', height: 'auto' }}
                      preview={{
                        mask: 'Click to preview',
                      }}
                    />
                  </div>
                  {dataToRender?.signatureCompletedAt && (
                    <p style={{ fontSize: '12px', color: '#666', margin: 0 }}>
                      Completed: {new Date(dataToRender.signatureCompletedAt).toLocaleString()}
                    </p>
                  )}
                </div>
              )}
              
              {dataToRender?.idDocumentUrl && (
                <div style={{ flex: 1, minWidth: '300px' }}>
                  <h3>ID Document</h3>
                  <div style={{ border: '1px solid #d9d9d9', borderRadius: '4px', padding: '8px', marginBottom: '8px' }}>
                    <Image 
                      src={dataToRender.idDocumentUrl} 
                      alt="ID Document"
                      style={{ maxWidth: '100%', height: 'auto' }}
                      preview={{
                        mask: 'Click to preview',
                      }}
                    />
                  </div>
                  {dataToRender?.idDocumentFilename && (
                    <p style={{ fontSize: '12px', color: '#666', margin: 0 }}>
                      Filename: {dataToRender.idDocumentFilename}
                    </p>
                  )}
                </div>
              )}
            </Flex>
            
            {!dataToRender?.digitalSignature && !dataToRender?.idDocumentUrl && (
              <p style={{ textAlign: 'center', color: '#666', padding: '40px 0' }}>
                No signature or ID verification data available for this report.
              </p>
            )}
          </div>
        </StyledModal>
      )}

      {/* Establishment Management Components */}
      <PlacesContactsDrawer
        visible={establishmentDrawerVisible}
        onClose={() => {
          setEstablishmentDrawerVisible(false);
          setSelectedEstablishment(null);
        }}
        establishment={selectedEstablishment}
      />

      <EstablishmentLocationModal
        visible={establishmentModalVisible}
        onCancel={() => {
          setEstablishmentModalVisible(false);
          setSelectedEstablishment(null);
        }}
        onSave={handleSaveEstablishment}
        editingRecord={selectedEstablishment}
        establishmentTypeId={currentEstablishmentTypeId}
        loading={establishmentLoading}
      />
    </div>
  );
};

export default ReportDetailsBody;
